// @ts-nocheck

import { sectionRenderer, morphSection } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';
import { DialogComponent } from '@theme/dialog';

/* ———————————————————————————————————————— */
/* window extensions */
/* ———————————————————————————————————————— */

window.hasInteracted = false;
window.offerEngine = window.offerEngine || {};
window.transformParamValues = window.transformParamValues || transformParamValues;
window.offerEngine.parseJsonFromDrop = window.offerEngine.parseJsonFromDrop || parseJsonFromDrop;
window.offerEngine.prehydrateDrops = window.offerEngine.prehydrateDrops || prehydrateDrops;
window.offerEngine.parseActiveDiscountRate = window.offerEngine.parseActiveDiscountRate || parseActiveDiscountRate;
window.offerEngine.parseCurrentTs = window.offerEngine.parseCurrentTs || parseCurrentTs;
window.offerEngine.parseLiquidJsonArrayContent = window.offerEngine.parseLiquidJsonArrayContent || parseLiquidJsonArrayContent;
window.offerEngine.openOfferUpsell = openOfferUpsell;
window.offerEngine.cartFetch = window.offerEngine.cartFetch || cartFetch;
window.offerEngine.handleCartResponse = window.offerEngine.handleCartResponse || handleCartResponse;
window.offerEngine.dispatchCartRequests = window.offerEngine.dispatchCartRequests || dispatchCartRequests;
window.offerEngine.parseAddPayloadData = window.offerEngine.parseAddPayloadData || parseAddPayloadData;
window.offerEngine.handleAddPayloadData = window.offerEngine.handleAddPayloadData || handleAddPayloadData;
window.offerEngine.parseChangePayloadData = window.offerEngine.parseChangePayloadData || parseChangePayloadData;
window.offerEngine.parseUpdatePayloadData = window.offerEngine.parseUpdatePayloadData || parseUpdatePayloadData;
window.offerEngine.parseGiftVariantQuantities = parseGiftVariantQuantities;
window.offerEngine.parseGiftQualifyingQuantity = parseGiftQualifyingQuantity;
window.offerEngine.updateGiftVariantOptions = updateGiftVariantOptions;
window.offerEngine.parseGiftOptionSelections = parseGiftOptionSelections;
window.offerEngine.parseGiftItemQuantity = window.offerEngine.parseGiftItemQuantity || parseGiftItemQuantity;
window.offerEngine.parseGiftSubscriptionPlanId = window.offerEngine.parseGiftSubscriptionPlanId || parseGiftSubscriptionPlanId;
window.offerEngine.parseApplicableApplyOnlyTitles = window.offerEngine.parseApplicableApplyOnlyTitles || parseApplicableApplyOnlyTitles;

/* ———————————————————————————————————————— */
/* constants / contracts */
/* ———————————————————————————————————————— */

const MAIN_EL = document.querySelector('main');
const OFFER_CART_RESOLVED_EVENT = 'offer-engine:cart-resolved';
const CART_PREPARATION_EVENT = 'offer-engine:cart-preparation';
const CART_PREPARATION_FETCH_TIMEOUT_MS = 10000;
const RECART_EMAIL_CAPTURE_EVENT = 'recart:optin-tool:email-captured';
const MAX_BUNDLED_SECTION_COUNT = 5;
const MIN_PREORDER_DELAY_DAYS = 6;
const OFFER_REFRESH_STATE_ATTR = 'data-offer-refresh-state';
const OFFER_REFRESH_LOADING_STATE = 'loading';

const SELECTORS = {
    offerUpsellModal: 'custom-modal[data-modal-id="offer-upsell"]',
    offerUpsell: '[data-offer-upsell]',
    root: '[data-offer-config-root]',
    cartItemsComponent: 'cart-items-component',
    offerDisplayMap: '[data-offer-display-map]',
    jsonOffer: '[data-offer-config="offer"]',
    jsonOfferIds: '[data-offer-config="offer-ids"]',
    jsonDiscounts: '[data-offer-config="discounts"]',
    jsonDiscountIds: '[data-offer-config="discount-ids"]',
    jsonCartItems: '[data-offer-config="cart-items"]',
    jsonGiftSets: '[data-offer-config="gift-sets"]',
    jsonGiftSetIds: '[data-offer-config="gift-set-ids"]',
    jsonGiftItems: '[data-offer-config="gift-items"]',
    jsonGiftItemIds: '[data-offer-config="gift-item-ids"]',
    priceWrapper: '[data-content="product-prices"][data-item-id]',
    localPriceScopeDetails: '[data-testid="product-information-details"]',
    localPriceScopeSection: '[data-testid="product-information"]',
    giftDisplay: '[data-content="gift-display"]',
    giftDisplayUnlockedCount: '[data-content="gift-unlocked-count"]',
    giftDisplayDelta: '[data-content="gift-threshold-delta"]',
    giftDisplayItem: '[data-gift-display-item]',
    cartGiftDisplay: '[data-content="cart-drawer-gifts"]',
    variantModalForm: '[data-content="variant-selection"]',
    cartPreorderToggle: 'input[type="checkbox"][name="preorder-toggle"]',
};

const ATTR = {
    action: 'data-action',
    modalId: 'data-modal-id',
    toggles: 'data-toggles',
    toggleValue: 'data-toggle-value',
    offerHandle: 'data-offer-handle',
    giftSetIndex: 'data-gift-set-index',
    giftSetId: 'data-gift-set-id',
    itemId: 'data-item-id',
    discountId: 'data-discount-id',
    offerConfig: 'data-offer-config',
};

const ACTIONS = {
    applyOfferFromUrl: 'offer:apply-from-url',
    applyOffer: 'offer:apply',
    refreshOfferSection: 'offer:refresh-section',
};

const SESSION_KEYS = {
    cart_discounts: 'cartDiscountCodes',
    cart_items: 'cartItems',
    session_offer_applied: '__offerAppliedInSession'
}

const LOCAL_STORAGE_KEYS = {
    custom_search_prefix: 'taoCustomSearch:',
}

const TOGGLES = {
    preorderActive: 'preorder-active',
}

const URL_PARAM_UTILITIES = {
    offer: handleUrlOfferApplication,
    reset_offer: handleUrlOfferReset,
    reset_search_cache: handleUrlSearchCacheReset,
    discount: handleUrlDiscount
}

const CART_ROUTES = {
    get: Theme?.routes?.cart_url || '/cart.js',
    update: Theme?.routes?.cart_update_url || '/cart/update.js',
    add: Theme?.routes?.cart_add_url || '/cart/add.js',
    change: Theme?.routes?.cart_change_url || '/cart/change.js',
}

const CART_UPDATE_SECTION_IDS = {
    offer_config: 'offer-engine-json',
    announcement_bar: document.querySelector('.announcement-bar')?.closest('.shopify-section')?.id.replace('shopify-section-', '') ?? null,
    price_sections: readPriceSectionIds,
    cart_sections: readCartComponentSectionIds,
}

const CART_UPDATE_SECTION_RESOLVERS = {
    'offer-engine-json': handleOfferJsonReplacement,
    'announcement-bar': handleAnnouncementCartUpdates,
    'header': handleHeaderCartUpdates,
    'cart-page': handleCartPageUpdates,
    'pricing': handleSectionPricingUpdates,
    'product-recommendations': handleDynamicRecCartUpdates,
}

const PREORDER_LINE_PROPS = [
    '_isPreorder',
    '_preorder_price',
    '_preorder_discount_rate',
    '_preorder_market_currency',
    '_preorder_original_msrp',
    '_added_in_market',
]

const PREORDER_CART_ATTRS = [
    '_preorder_eligible',
    '_preorder',
    '_preorder_ship_delay',
    '_preorder_rules_ids',
]

const OFFER_RESET_INPUT = {
    attributes: {
        _offer_handle: null,
        _offer_applied_ts: null,
        _gift_pill_style: null,
        _variant_image_style: null,
        _preorder: null,
        _preorder_eligible: null,
        _preorder_ship_delay: null,
        _preorder_rules_ids: null,
        _gift_set_ids: null,
        _gift_item_ids: null,
        _gift_sub_mode: null,
        _gift_sub_products: null,
        _gift_sub_offer: null,
        _gift_sub_interval: null,
        _freeship_mode: null,
        _freeship_threshold: null,
        _shipping_promise: null,
    },
    discount: '',
}

const DEFAULT_CONFIG_PARAMS = {
    discounts: [],
    preorder_rules: [],
    variant_price_overrides: [],
    gift_sets: [],
    gift_items: [],
    gift_item_products: [],
    offer: {}
}

const CART_ATTR_DEPENDENCIES = {
    _offer_handle: [{key: '_offer_applied_ts', handler: parseCurrentTs}],
}

// offer json key > cart attribute key. Assumes value can match
const OFFER_ATTR_BINDINGS = {
    freeship_mode: "_freeship_mode",
    freeship_threshold: "_freeship_threshold",
}

const OFFER_PAGE_PATH_FRAGMENT = '/pages/op/';
const OFFER_CHANGE_EVENT = 'offer-engine:offer-change';
const INIT_FLAG = '__offerEngineInit';
const BOOT_FLAG = '__offerEngineBooted';

const util = window.util || null;

const DISCOUNT_OFFER_BINDINGS = [
    {
        offer: 'cleankids',
        discount_codes: ['cleankids'],
    },
    {
        offer: 'hotandflashy',
        discount_codes: ['hotandflashy'],
    },
    {
        offer: 'stayclean',
        discount_codes: ['stayclean', '3d102y37x1g7fcnz'],
    },
    {
        offer: 'smile50',
        discount_codes: ['face50', 'smile50'],
    },
    {
        offer: 'cart60',
        discount_codes: ['glow60', '60memorial-nogwp', 'cart60', 'welcome', 'taoclean60', 'first60'],
    },
    {
        offer: 'blackfriday-4d',
        discount_codes: ['blackfriday-1d', 'blackfriday-2d', 'blackfriday-3d', 'blackfriday-4d'],
    },
    {
        offer: 'blackfriday60-4d',
        discount_codes: ['blackfriday60-1d', 'blackfriday60-2d', 'blackfriday60-3d', 'blackfriday60-4d'],
    },
    {
        offer: 'reserve-40-switch-4-1',
        discount_codes: ['reserve40-switch-4', 'reserve40-switch-4g', 'reserve40-switch'],
    },
    {
        offer: 'reserve-40-switch-4-f-1',
        discount_codes: ['reserve40-switch-4f1'],
    },
    {
        offer: 'reserve-3c',
        discount_codes: ['reserve-1c', 'reserve-2c', 'reserve-3c'],
    },
    {
        offer: 'reserve65',
        discount_codes: ['presale55', 'presale60', 'presale65'],
    },
    {
        offer: 'reserve65',
        discount_codes: ['reserve55', 'reserve60', 'reserve65'],
    },
    {
        offer: 'reserve65',
        discount_codes: ['reserve55-switch', 'reserve60-switch', 'reserve65-switch'],
    },
    {
        offer: 'reserve50',
        discount_codes: ['reserve50','reserve50-switch','50memorial','50memorial-switch','60memorial','reserve50-1','freeshipsub50'],
    },
    {
        offer: 'bundle60',
        discount_codes: ['bundle60'],
    },
    {
        offer: 'reserve-40-switch-intl',
        discount_codes: ['reserve40-switch-intl'],
    },
    {
        offer: 'reserve-40-switch-ir',
        discount_codes: ['reserve40-switch-ir'],
    },
    {
        offer: 'reserve-40-switch-uk',
        discount_codes: ['reserve40-switch-uk'],
    },
    {
        offer: 'first15',
        discount_codes: ['save15', 'vip15', 'first15'],
    },
    {
        offer: 'refill20',
        discount_codes: ['refill20', 'sub20'],
    },
    {
        offer: 'replacementheadsbundle15',
        discount_codes: ['replacementheadsbundle5','replacementheadsbundle10','replacementheadsbundle15'],
    },
    {
        offer: 'reserve-40-switch-4-f',
        discount_codes: ['reserve40-switch-4f'],
    },
    {
        offer: 'reserve-40-switch-4-f-2',
        discount_codes: ['reserve40-switch-4f2'],
    },
    {
        offer: 'reserve-40-switch-4-f-3',
        discount_codes: ['reserve40-switch-4f3'],
    },
    {
        offer: 'reserve-40-switch-4-f-4',
        discount_codes: ['reserve40-switch-4f4', 'reserve40-switch-4f5'],
    },
]

const LEGACY_CART_CONVERSION_ATTR = '_legacy_cart_conversion';
const LEGACY_CART_CONVERSION_VALUE = 'true';
const LEGACY_CART_CONVERSION_BLOCKER_HANDLE = 'legacy-cart-conversion';
const LEGACY_CART_CONVERSION_BLOCKER_MS = 30000;
const LEGACY_CART_CONVERSION_OVERLAY_ATTR = 'data-legacy-cart-conversion-overlay';
const LEGACY_CART_CONVERSION_MESSAGE_ATTR = 'data-legacy-cart-conversion-message';
const LEGACY_CART_CONVERSION_PROGRESS_MS = 2000;
const LEGACY_CART_CONVERSION_SUCCESS_DELAY_MS = 500;
const LEGACY_LINE_PROP_DROPS = [
    'is_gift',
    '_gift_session_id',
    '_gift_quantity_threshold',
    '_ship_by',
    '_compare_display_value',
    '_offer_line_items_0',
    '_original_msrp',
    '_unlocalized_msrp',
    '_preorder_unlocalized_price_target',
];

/* ———————————————————————————————————————— */
/* module state */
/* ———————————————————————————————————————— */

let activeOfferUpsell = null;
let eventHandlersBound = false;
let firstInteractionPromise = null;
let firstInteractionAdd = null;
let firstInteractionAcceptsAdd = false;
let configParams = {};
let configState = {};
let TRANSITION_UI_ACTIVE = false;
let cachedConfig = null;
let cachedConfigRoot = null;
let cachedDiscountKey = '';
let cachedCartState = null;
let offerUpdateToken = 0;
let activeDiscountDisplayAttr = null;
let giftSyncToken = 0;
let cartMutationLogId = 0;
let cartValidationInFlight = null;
let lastCartValidationAt = 0;
let scheduledGiftValidationTimer = null;
let giftValidationSuppressionDepth = 0;
const giftEditorSessions = new WeakMap();
let isGiftEditPending = false;
let offerTransitionDepth = 0;
let klaviyoOfferBlocker = null;
let klaviyoOfferBlockerHandle = null;
let legacyCartConversionTimers = [];
// True while the Klaviyo popup is open (set on its open/close events). Guards the
// anti-nag blocker from tearing down a multi-step popup the user is still filling in.
let klaviyoFormOpen = false;
// Counts step submissions within one popup session (reset on open) so we can dismiss
// the popup after the final data step and skip Klaviyo's native success page.
let klaviyoStepSubmits = 0;

const EVENT_HANDLERS = {
    click: new Map([
        ['[data-action="cart:retry-preparation"]', { handler: handleCartPagePreparationRetry }],
        ['[data-action="gift:add"]', { handler: handleGiftVariantAdd }],
        ['[data-action="gift:edit"]', { handler: handleCartGiftEdit }],
        ['[data-action="gift:confirm"]', { handler: handleCartGiftConfirm }],
        ['[data-action="gift:cancel"]', { handler: handleCartGiftCancel }],
        ['[data-action="upsell:select"]', { handler: handleOfferUpsellSelect }],
        ['[data-action="upsell:add"]', { handler: handleOfferUpsellAdd }],
        ['[data-action="upsell:skip"]', { handler: handleOfferUpsellSkip }],
    ]),
    change: new Map([
        ['[data-action="gift:select"]', { handler: handleGiftVariantSelect }],
        [SELECTORS.offerUpsell, { handler: updateOfferUpsell }],
    ]),
    [ThemeEvents.quantitySelectorUpdate]: new Map([
        ['[data-gift-variant-options]', { handler: handleGiftVariantQuantity }],
        [SELECTORS.offerUpsell, { handler: updateOfferUpsell }],
    ]),
    'dialog:close': new Map([
        ['[data-cart-gift-editor]', { handler: handleCartGiftEditorClose }],
    ]),
    'modal:closed': new Map([
        [SELECTORS.offerUpsellModal, { handler: handleOfferUpsellClose }],
    ]),
    // click: new Map([
    //     [SELECTORS.preorderToggle, { 
    //         handler: handlePreorderToggleClick,
    //         hydrate: true,
    //         hydrateAfter: true
    //     }],
    //     [SELECTORS.resetModalLines, { 
    //         handler: handleModalClose,
    //     }],
    //     [SELECTORS.lineSelectButton, { 
    //         handler: handleLineSelect,            
    //     }],
    //     [SELECTORS.addToCartButton, { 
    //         handler: handleAddToCart,
    //         hydrate: true,
    //     }],
    // ]),
    // change: new Map([
    //     [SELECTORS.baseQuantityInput, { 
    //         handler: handleBaseQuantityChange,
    //         hydrate: true,
    //     }],
    // ]),
    input: new Map([
        ['[data-gift-quantity]', { handler: handleGiftVariantQuantity }],
        [SELECTORS.offerUpsell, { handler: updateOfferUpsell }],
        [SELECTORS.cartPreorderToggle, { 
            handler: handleCartPreorderToggle,
        }],
    ]),
    // [ThemeEvents.quantitySelectorUpdate]: new Map([
    //     [SELECTORS.quantityGroup, { 
    //         handler: handleQuantityInput,
    //         hydrate: true,
    //     }],
    // ]),
    pointerdown: {
        firstInteraction: handleFirstInteraction,
        options: { once: true, passive: true },
    },
    keydown: {
        firstInteraction: handleFirstInteraction,
        options: { once: true, passive: false },
    },
    touchstart: {
        firstInteraction: handleFirstInteraction,
        options: { once: true, passive: true },
    },
    focusin: {
        firstInteraction: handleFirstInteraction,
        options: { once: true, passive: true },
    },
};

const KLAVIYO_EVENT_HANDLERS = {
    open: handleKlaviyoFormOpen,
    submit: handleKlaviyoFormSubmit,
    stepSubmit: handleKlaviyoStepSubmit,
    close: handleKlaviyoFormClose,
}

/* ———————————————————————————————————————— */
/* init / boot */
/* ———————————————————————————————————————— */

initOfferEngine();

function initOfferEngine() {
    try {
        initOnce();
        const root = document.querySelector(SELECTORS.root) || document.querySelector('main');
        configParams = hydrateConfigParams(root);
        configState = hydrateConfigState(configParams);
        updateKlaviyoOfferBlocker();
        initBootFlowOnce();
    } catch (error) {
        // Never allow offer engine to break the theme
        console.error('[OfferEngine] init failed', error);
    }
}

function initOnce() {
    if (window[INIT_FLAG]) return;
    window[INIT_FLAG] = true;
    initEventHandlers();
    //document.addEventListener('click', handleDocumentClick);
    //document.addEventListener(ThemeEvents.cartUpdate, handleCartChange);
    //document.addEventListener(ThemeEvents.quantitySelectorUpdate, handleFormQuantityChange);
    //window.addEventListener('pageshow', handlePageShow);
    //window.addEventListener('focus', handleWindowFocus);
    //window.addEventListener('popstate', handleHistoryNavigation);
    //document.addEventListener('visibilitychange', handleVisibilityChange);
}

function initBootFlowOnce() {
    if (window[BOOT_FLAG]) return;
    window[BOOT_FLAG] = true;
    if (MAIN_EL?.hasAttribute('data-cart-preparation')) {
        window.hasInteracted = true;
        firstInteractionPromise = handleCartPagePreparation();
        return;
    }
    void handleBootFlow();
}

async function handleCartPagePreparation() {
    document.dispatchEvent(new CustomEvent(CART_PREPARATION_EVENT, {
        detail: { state: 'pending' },
    }));
    try {
        await handleBootFlow();
        const resolved = await checkHydrationValidity({ reason: 'cart-startup' });
        if (!resolved) throw new Error('Cart preparation failed');

        MAIN_EL.inert = false;
        MAIN_EL.removeAttribute('aria-busy');
        const status = document.querySelector('[data-content="cart-preparation-status"]');
        if (status) status.hidden = true;
        document.dispatchEvent(new CustomEvent(CART_PREPARATION_EVENT, {
            detail: { state: 'ready' },
        }));
    } catch (error) {
        document.dispatchEvent(new CustomEvent(CART_PREPARATION_EVENT, {
            detail: { state: 'error', retryable: true },
        }));
        console.error('[OfferEngine] Cart preparation failed', error);
    } finally {
        firstInteractionPromise = null;
    }
}

/** Retry cart-page validation without starting overlapping cart mutations. */
function handleCartPagePreparationRetry() {
    if (!MAIN_EL?.hasAttribute('data-cart-preparation') || firstInteractionPromise) return;
    firstInteractionPromise = handleCartPagePreparation();
}

async function handleBootFlow() {
    const handledUrlParams = await handleUrlParams();
    if (handledUrlParams) return;

    const handledLegacyCart = await handleLegacyCartConversion();
    if (handledLegacyCart) return;

    await handleBootMarketOfferValidation();
}

/* ———————————————————————————————————————— */
/* event handlers */
/* ———————————————————————————————————————— */

function initEventHandlers() {
    if (eventHandlersBound) return;
    eventHandlersBound = true;

    window.addEventListener('klaviyoForms', (e) => {
        const klHandler = KLAVIYO_EVENT_HANDLERS[e.detail?.type];
        if (typeof klHandler === 'function') {
            klHandler(e);
        }
    });

    window.addEventListener(RECART_EMAIL_CAPTURE_EVENT, handleRecartEmailCaptured);

    Object.entries(EVENT_HANDLERS).forEach(([eventType, config]) => {
        const handler = config instanceof Map
            ? handleDelegatedEvent
            : config?.firstInteraction;
        if (typeof handler !== 'function') return;

        // Native dialog lifecycle events do not bubble.
        document.addEventListener(eventType, handler, eventType === 'dialog:close' ? { capture: true } : config?.options);
    });
}

async function handleKlaviyoFormSubmit(event) {
    const configRoot = document.querySelector(SELECTORS.root);
    if (!configRoot) return;

    const apply = configRoot.dataset.applyOfferOn && configRoot.dataset.applyOfferOn.toLowerCase() === 'email-capture';
    if (!apply) return;

    const offerHandle = configRoot.dataset.marketDefaultOffer || null;
    if (!offerHandle) return;

    // Multi-step popup: apply the offer silently and let Klaviyo advance to the
    // phone step, instead of tearing the popup down on the email submit.
    return applyKlaviyoOfferSilently(offerHandle);
}

async function handleRecartEmailCaptured() {
    const configRoot = document.querySelector(SELECTORS.root);
    if (!configRoot) return;

    const apply = configRoot.dataset.applyOfferOn
        && configRoot.dataset.applyOfferOn.toLowerCase() === 'email-capture';
    if (!apply) return;

    const offerHandle = configRoot.dataset.marketDefaultOffer || null;
    if (!offerHandle) return;

    return applyRecartOfferSilently(offerHandle);
}

// Apply the market default offer without interrupting Recart's remaining popup steps.
// The standard offer:set reconciliation still updates gifts, discounts, and pricing.
async function applyRecartOfferSilently(offerHandle) {
    const updateParams = {
        attributes: {
            _offer_handle: offerHandle,
        }
    };
    const context = 'offer:set';
    const requests = parseOfferUpdateInputs(null, updateParams, context);

    try {
        await dispatchCartRequests({
            requests,
            context,
            init: false,
            resolve: false,
            previous_offer_handle: window.cartAttributes?._offer_handle ?? null,
        });
    } catch (error) {
        console.error('[OfferEngine] Recart silent offer application failed', error);
        return false;
    }

    return true;
}

// Apply the market default offer to the cart in the background — no hide, blocker,
// reload, or transition overlay — so a multi-step Klaviyo popup can continue to its
// phone step. init:false suppresses startOfferTransitionUi(); the offer:set
// reconciliation (gifts/pricing) still runs. Anti-nag on later page loads is
// unaffected — it runs off the boot-time updateKlaviyoOfferBlocker().
async function applyKlaviyoOfferSilently(offerHandle) {
    const updateParams = {
        attributes: {
            _offer_handle: offerHandle,
        }
    }
    const context = 'offer:set';
    const requests = parseOfferUpdateInputs(null, updateParams, context);

    try {
        await dispatchCartRequests({
            requests,
            context,
            init: false,
            resolve: false,
            previous_offer_handle: window.cartAttributes?._offer_handle ?? null,
        });
    } catch (error) {
        console.error('[OfferEngine] Klaviyo silent offer application failed', error);
        return false;
    }

    return true;
}

function handleKlaviyoFormOpen() {
    klaviyoFormOpen = true;
    klaviyoStepSubmits = 0;
}

function handleKlaviyoFormClose() {
    klaviyoFormOpen = false;
}

function handleKlaviyoStepSubmit() {
    klaviyoStepSubmits += 1;
    // Dismiss the popup once the final data step (the phone step — the 2nd step submit
    // in the email -> phone form) is submitted, so Klaviyo's native success page never
    // renders (the old single-step popup was likewise dismissed on completion). The
    // offer was already applied on the email step, and Klaviyo captures each step's
    // data as part of the submission that fires this event, so removing the UI now
    // doesn't drop the phone number. Assumes two data steps; revisit if steps change.
    if (klaviyoStepSubmits < 2) return;
    const offerHandle = document.querySelector(SELECTORS.root)?.dataset.marketDefaultOffer || null;
    klaviyoFormOpen = false;
    if (offerHandle) startKlaviyoOfferBlocker(offerHandle);
}

function updateKlaviyoOfferBlocker(cartAttributes = window.cartAttributes || {}) {
    const offerHandle = util.normalize.text(cartAttributes?._offer_handle || '');

    if (!offerHandle) {
        disposeKlaviyoOfferBlocker();
        return;
    }

    startKlaviyoOfferBlocker(offerHandle);
}

function startKlaviyoOfferBlocker(offerHandle, observeMs = 5000) {
    if (!offerHandle) return;
    // Never tear down a multi-step popup while the user is still in it. The offer is
    // written to the cart mid-flow (on email capture), which re-trips this anti-nag
    // blocker via handleCartResponse; skip it while the form is open. Boot-time
    // anti-nag is unaffected (the form isn't open yet on load) and resumes on close.
    if (klaviyoFormOpen) return;
    if (klaviyoOfferBlocker && klaviyoOfferBlockerHandle === offerHandle) return;

    disposeKlaviyoOfferBlocker();
    klaviyoOfferBlocker = initKlaviyoBlocker(observeMs);
    klaviyoOfferBlockerHandle = offerHandle;
}

function disposeKlaviyoOfferBlocker() {
    if (!klaviyoOfferBlocker) return;

    try {
        klaviyoOfferBlocker.dispose();
    } catch (error) {
        console.warn('[OfferEngine] Unable to dispose Klaviyo blocker', error);
    }

    klaviyoOfferBlocker = null;
    klaviyoOfferBlockerHandle = null;
}

function initKlaviyoBlocker(observeMs = 5000) {
    const debug = false;
    const log = (...args) => {
        if (debug) console.log('[OfferEngine] Klaviyo blocker', ...args);
    };

    const POPUP_SELECTORS = [
        '.klaviyo-form',
        '[class*="klaviyo-form-"]',
        '.klaviyo-overlay',
        '.klaviyo-popup',
        '.klaviyo-modal',
        '.klaviyo-teaser',
        '[class*="kl-teaser"]',
        'iframe[src*="klaviyo"]',
        '[id^="klaviyo-"]',
        /* Recart also uses needsclick on its popup host; keep this selector Klaviyo-scoped. */
        '.needsclick[class*="kl-private-reset-css"]',
    ];

    function nuke(root = document) {
        for (const sel of POPUP_SELECTORS) {
            root.querySelectorAll(sel).forEach((node) => {
                node.remove();
            });
        }
    }

    document.body?.classList.add('klaviyo--bypass');
    nuke();

    const BLOCKED_CMDS = new Set(['openForm', 'open', 'showForm', 'toggleForm']);
    const q = (window._klOnsite = Array.isArray(window._klOnsite) ? window._klOnsite : []);

    for (let i = q.length - 1; i >= 0; i--) {
        const item = q[i];
        if (!Array.isArray(item)) continue;

        const head = Array.isArray(item[0]) ? item[0] : item;
        if (Array.isArray(head) && BLOCKED_CMDS.has(head[0])) q.splice(i, 1);
        else if (!Array.isArray(item[0]) && BLOCKED_CMDS.has(item[0])) q.splice(i, 1);
    }

    const originalPush = q.push;
    q.push = function (...args) {
        const kept = [];

        for (const arg of args) {
            if (!Array.isArray(arg)) continue;

            if (Array.isArray(arg[0])) {
                const filtered = arg.filter((cmd) => !(
                    Array.isArray(cmd) && BLOCKED_CMDS.has(cmd[0])
                ));
                if (filtered.length) kept.push(filtered);
                else log('Dropped batched popup cmds');
            } else {
                if (BLOCKED_CMDS.has(arg[0])) log('Dropped popup cmd:', arg[0]);
                else kept.push(arg);
            }
        }

        return kept.length ? originalPush.apply(q, kept) : q.length;
    };

    const noop = () => {};
    try {
        if (window.klaviyo) {
            window.klaviyo.openForm = noop;
            window.klaviyo.showForm = noop;
        }
        if (window.Klaviyo) {
            window.Klaviyo.openForm = noop;
            window.Klaviyo.showForm = noop;
        }
    } catch {}

    const mo = new MutationObserver((muts) => {
        for (const m of muts) {
            m.addedNodes && m.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) return;

                const html = node.outerHTML || '';
                if (/klaviyo/i.test(html)) {
                    nuke(document);
                } else {
                    for (const sel of POPUP_SELECTORS) {
                        if (
                            (node.matches && node.matches(sel))
                            || (node.querySelector && node.querySelector(sel))
                        ) {
                            nuke(document);
                            break;
                        }
                    }
                }
            });
        }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const timer = setTimeout(() => {
        mo.disconnect();
    }, observeMs);

    function dispose() {
        clearTimeout(timer);
        mo.disconnect();
        try {
            q.push = originalPush;
        } catch {}
    }

    return { dispose };
}

function handleFirstInteraction() {
    if (window.hasInteracted) return firstInteractionPromise;
    window.hasInteracted = true;
    if (checkIsOfferPage()) return;

    firstInteractionAcceptsAdd = true;
    firstInteractionPromise = new Promise((resolve) => {
        window.setTimeout(resolve, 0);
    }).then(async () => {
        const resolved = await checkHydrationValidity({ reason: 'first-interaction' });
        if (resolved === false) throw new Error('Cart preparation failed');
    }).catch((error) => {
        window.hasInteracted = false;
        throw error;
    }).finally(() => {
        firstInteractionPromise = null;
        firstInteractionAdd = null;
        firstInteractionAcceptsAdd = false;
    });
    // Background interactions have no awaiting product form to consume a rejection.
    void firstInteractionPromise.catch((error) => {
        console.warn('[OfferEngine] First-interaction preparation failed', error);
    });
    return firstInteractionPromise;
}

function handleDelegatedEvent(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const handlers = EVENT_HANDLERS[event.type];
    if (!(handlers instanceof Map)) return;

    for (const [selector, config] of handlers.entries()) {
        const el = target.closest(selector);
        if (!el) continue;

        const handler = config?.handler;
        if (typeof handler !== 'function') break;

        handler(event, el);
        break;
    }
}

/* ———————————————————————————————————————— */
/* hydration / validation */
/* ———————————————————————————————————————— */

function transformParamValues(type, data) {
    switch (type) {
        case 'offer': {
            const freeshipMode = parseFreeshipMode(data.free_shipping_threshold_type);
            const freeshipThreshold = parseFreeshipThreshold(freeshipMode, data);
            return {
                ...data,
                freeship_mode: freeshipMode,
                freeship_threshold: freeshipThreshold,
            }
        }
        case 'discounts': {
            const discounts = Array.isArray(data)
                ? data
                : Object.entries(data || {}).map(([id, discount]) => ({
                    ...discount,
                    id: util.extract.idFromGid(id),
                }));
        
            return discounts.map((discount) => {
                // Classified on the RAW amount: the normalization below falls back
                // to 1, which must never turn an apply-only discount (e.g. free
                // shipping, synced as 'Fixed amount' 0.0) into a product discount.
                const isProductDiscount = discount.type === 'Amount off products'
                    && discount.amount !== null && discount.amount !== undefined && discount.amount !== '';
                return {
                    ...discount,
                    is_product_discount: isProductDiscount,
                    amount: util.normalize.number(discount.amount, { fallback: 1 }),
                    preorder_rules: Array.isArray(discount.preorder_rules)
                        ? discount.preorder_rules.map((rule) => util.extract.idFromGid(rule))
                        : [],
                    variant_price_overrides: Array.isArray(discount.variant_price_overrides)
                        ? discount.variant_price_overrides.map((rule) => util.extract.idFromGid(rule))
                        : [],
                    product_ids: Array.isArray(discount.product_ids)
                        ? discount.product_ids.map((id) => util.normalize.number(id))
                        : [],
                    variant_ids: Array.isArray(discount.variant_ids)
                        ? discount.variant_ids.map((id) => util.normalize.number(id))
                        : [],
                    // Apply-only discounts never reach pricing display; parsing them
                    // would also hit method shapes this fn does not support.
                    display_amount: isProductDiscount ? parseDiscountDisplayContent(discount) : null,
                };
            });
        }

        case 'preorder_rules': {
            const rules = Array.isArray(data)
                ? data
                : Object.entries(data || {}).map(([id, rule]) => ({
                    ...rule,
                    id: util.extract.idFromGid(id),
                }));

            return rules.map((rule) => ({
                ...rule,
                price_preorder: {
                    ...rule.price_preorder,
                    amount: util.normalize.number(rule.price_preorder?.amount) * 100,
                },
                products: Array.isArray(rule.products)
                    ? rule.products.map((product) => util.extract.idFromGid(product))
                    : [],
                variants: Array.isArray(rule.variants)
                    ? rule.variants.map((variant) => util.extract.idFromGid(variant))
                    : [],
            }));
        }

        case 'variant_price_overrides': {
            const rules = Array.isArray(data)
                ? data
                : Object.entries(data || {}).map(([id, rule]) => ({
                    ...rule,
                    id: util.extract.idFromGid(id),
                }));

            return rules.map((rule) => ({
                ...rule,
                price: {
                    ...rule.price,
                    amount: util.normalize.number(rule.price?.amount) * 100,
                },
                compare_at_price: {
                    ...rule.compare_at_price,
                    amount: util.normalize.number(rule.compare_at_price?.amount) * 100,
                },
                variants: Array.isArray(rule.variants)
                    ? rule.variants.map((variant) => util.extract.idFromGid(variant))
                    : [],
            }));
        }

        case 'gift_sets': {
            const giftSets = Array.isArray(data)
                ? data
                : Object.entries(data || {}).map(([id, giftSet]) => ({
                    ...giftSet,
                    id: util.extract.idFromGid(id),
                }));
            return giftSets.map((giftSet) => ({
                ...giftSet,
                qualifier_variant_ids: Array.isArray(giftSet.qualifier_variant_ids)
                    ? giftSet.qualifier_variant_ids.map((id) => util.normalize.number(id))
                    : [],
                gift_items: Array.isArray(giftSet.gift_items)
                    ? giftSet.gift_items.map((item) => util.extract.idFromGid(item))
                    : [],
            }));
        }
       
        case 'gift_items':
            if (!Array.isArray(data)) return [];
            return data.map((giftItem) => {
                const item = { ...giftItem };
                if (item.id) item.id = util.extract.idFromGid(String(item.id));
                if (item.compare_at_price?.amount) item.compare_at_price.amount = util.normalize.number(item.compare_at_price.amount) * 100;
                if (item.variant_ids) item.variant_ids = item.variant_ids.map((id) => util.normalize.number(id));
                if (item.qualifier_products) delete item.qualifier_products;
                if (item.qualifier_variants) delete item.qualifier_variants;
                return item;
            });

        case 'cart_items':
            return window.lastCart?.items ? window.lastCart.items : parseLiquidCartItems(data);

        default:
            return data;
    }
}

async function checkHydrationValidity(options = {}) {
    const currentCart = await cartFetch('get', {}, false, {
        timeoutMs: CART_PREPARATION_FETCH_TIMEOUT_MS,
    });
    if (!currentCart?.token || !Array.isArray(currentCart.items)) {
        throw new Error('Unable to read the cart for preparation');
    }
    await handleCartResponse({ confirmed_cart: currentCart }, true);

    const updateStates = parseCartReconciliationState(window.config.params, currentCart);
    const updateRequired = Object.values(updateStates.type_states).filter(v => v === true).length > 0 ? true : false;
    if (options.reason === 'first-interaction') {
        firstInteractionAcceptsAdd = false;
        if (firstInteractionAdd) {
            if (updateRequired && updateStates.requests.length) {
                firstInteractionAdd.reconciliation = updateStates.plan;
            }
            return;
        }
    }
    if (!updateRequired || !updateStates.requests.length) return true;
    // If an update is needed, we need to handle the updates
    return await dispatchCartRequests({requests: updateStates.requests, cart_loading: true, cart: currentCart, validate_response: options.reason === 'cart-startup'});
}


function prehydrateDrops(drops) {
    if (!drops.length) return {};

    const next = {};
    drops.forEach((el) => {
        const drop = offerEngine.parseJsonFromDrop(el);
        if (!drop || !drop.key) return;
        next[drop.key] = transformParamValues(drop.key, drop.data);
    });
    return finalizeHydration(next);
}

function finalizeHydration(config) {
    filterUnavailableGiftItemVariants(config);

    // Apply-only discounts (free shipping etc.): their titles are applied to the
    // cart as codes, but the objects never enter the pricing pipeline. Split here
    // so BOTH hydration consumers (engine and offer-page.js) get the filtered set.
    // Type rides along: shipping-type apply-only codes are suppressed while a
    // subscription line is in cart (see checkApplyOnlySuppressed).
    const allHydratedDiscounts = Array.isArray(config.discounts) ? config.discounts : [];
    config.apply_only_discounts = allHydratedDiscounts
        .filter((discount) => !discount.is_product_discount && discount.title)
        .map((discount) => ({ title: discount.title, type: discount.type || '' }));
    config.discounts = allHydratedDiscounts.filter((discount) => discount.is_product_discount);

    if ((!config.preorder_rules || !config.preorder_rules.length) && (!config.variant_price_overrides || !config.variant_price_overrides.length)) return config;
    if (config.preorder_ship_dates || Object.keys(config.preorder_ship_dates).length === 0) {
        config.preorder_rules.forEach((rule) => {  
            rule.delay_days = config.preorder_ship_dates[rule.id];
        });
    
        delete config.preorder_ship_dates;
    }

    if (config.variant_price_overrides && config.variant_price_overrides.length && config.discounts && config.discounts.length) {
        config.discounts.forEach((discount) => {
            if (discount.variant_price_overrides && discount.variant_price_overrides.length) {
                discount.variant_price_overrides.forEach((ruleId) => {
                    const rule = config.variant_price_overrides.find(rule => rule.id === ruleId);
                    if (rule) {
                        if (!rule.discount_ids) rule.discount_ids = [];
                        rule.discount_ids.push(discount.id);
                    }
                });
            }
        });
    }

    return config;
}

function filterUnavailableGiftItemVariants(config = {}) {
    if (!Array.isArray(config.gift_items) || !Array.isArray(config.gift_item_products)) return config;

    config.gift_items.forEach((giftItem) => {
        if (!Array.isArray(giftItem.variant_ids) || !giftItem.variant_ids.length) return;

        giftItem.variant_ids = giftItem.variant_ids.filter((variantId) => (
            checkGiftVariantAvailable(config.gift_item_products, variantId)
        ));
    });

    return config;
}

function checkGiftVariantAvailable(products = [], variantId) {
    const normalizedVariantId = util.normalize.number(variantId);
    if (!normalizedVariantId) return false;

    return products.some((product) => (
        Array.isArray(product.variants)
        && product.variants.some((variant) => (
            util.normalize.number(variant.id) === normalizedVariantId
            && variant.available === true
        ))
    ));
}

function parseActivePriceOverrides(overrides = [], discounts = []) {
    if (!overrides.length || !discounts.length) return [];
    return overrides.filter(override => discounts.some(discount => discount.variant_price_overrides.includes(override.id)));
}

function hydrateConfigParams(rootInput, shadow = false) {
    const root = rootInput ? rootInput : document.querySelector(SELECTORS.root);
    if (!root) {
        console.error('[OfferEngine] Unable to parse config params: No root element found');
        return;
    }

    const jsonDrops = root.querySelectorAll(`script[${ATTR.offerConfig}]`);
    const next = prehydrateDrops(jsonDrops);
    next.cart_attributes = window.cartAttributes;

    if (!window.config) window.config = {};
    if (!shadow) window.config.params = next;

    return next;
}

function hydrateConfigState(configParams = window.config?.params || {}, cart = parseCurrentCart()) {
    const activeDiscounts = parseActiveDiscounts(configParams.discounts, cart.items)
    const activePreorderRules = parseActivePreorderRules(configParams.preorder_rules, activeDiscounts)
    const activePreorderState = parsePreorderRuleState(activePreorderRules);

    const state = {
        active_discounts: activeDiscounts,
        active_preorder_rules: activePreorderRules,
        active_variant_price_overrides: parseActivePriceOverrides(configParams.variant_price_overrides, activeDiscounts),
        active_preorder: cart.attributes?._preorder === "true" ? true : false,
        active_preorder_delay: activePreorderState?.delay ?? null,
        eligible_preorder: cart.attributes?._preorder_eligible === "true" ? true : false,
    }

    if (!window.config) window.config = {};
    window.config.state = state;

    return state
}

/* ———————————————————————————————————————— */
/* offer application / reset */
/* ———————————————————————————————————————— */

async function handleUrlOfferApplication(data) {
    if (window.cartAttributes?._offer_handle 
        && (util.normalize.text(window.cartAttributes?._offer_handle) === util.normalize.text(data.value))
    || !data.value) return;

    if (!window.hasInteracted) window.hasInteracted = true;
    startKlaviyoOfferBlocker(data.value);

    const updateParams = {
        attributes: {
            _offer_handle: data.value,
        }
    }
    const context = "offer:set";
    const requests = parseOfferUpdateInputs(null, updateParams, context);
    await dispatchCartRequests({ requests, context, init: true, resolve: false, previous_offer_handle: window.cartAttributes?._offer_handle ?? null });
    
    return true;
}

// Safety gate so we can double check the {data} values before proceeding.
async function handleUrlOfferReset(data) {
    if (!util.transform.boolean(data.value)) return;
    if (!window.hasInteracted) window.hasInteracted = true;
    await handleOfferReset();

    return true
}

async function handleOfferReset() {
    const context = "offer:reset";
    const requests = parseOfferUpdateInputs(null, OFFER_RESET_INPUT, context);
    if (!requests.length || !checkResetNecessary(requests)) return;

    await dispatchCartRequests({ requests, context, init: true, resolve: false, previous_offer_handle: window.cartAttributes?._offer_handle ?? null });
    return;
}

async function handleBootMarketOfferValidation() {
    const validation = parseOfferValidationState(window.config?.params?.offer_validation);
    if (!validation.requires_update) return false;

    if (validation.action === 'swap') {
        return await handleMarketOfferSwap(validation.replacement_offer_handle);
    }

    if (validation.action === 'reset') {
        await handleOfferReset();
        return true;
    }

    return false;
}

async function handleMarketOfferSwap(offerHandle) {
    const normalizedOfferHandle = util.normalize.text(offerHandle);
    if (!normalizedOfferHandle) return false;
    if (
        window.cartAttributes?._offer_handle
        && util.normalize.text(window.cartAttributes?._offer_handle) === normalizedOfferHandle
    ) return false;

    startKlaviyoOfferBlocker(normalizedOfferHandle);

    const updateParams = {
        attributes: {
            _offer_handle: normalizedOfferHandle,
        }
    }
    const context = "offer:set";
    const requests = parseOfferUpdateInputs(null, updateParams, context);
    if (!requests.length) return false;

    await dispatchCartRequests({ requests, context, init: true, resolve: false, previous_offer_handle: window.cartAttributes?._offer_handle ?? null });
    return true;
}

function parseOfferValidationState(rawValidation = {}) {
    const action = util.normalize.text(rawValidation?.action || 'none').toLowerCase();
    const replacementOfferHandle = util.normalize.text(rawValidation?.replacement_offer_handle || '');

    if (action === 'swap' && replacementOfferHandle) {
        return {
            action,
            replacement_offer_handle: replacementOfferHandle,
            requires_update: true,
        };
    }

    if (action === 'reset') {
        return {
            action,
            replacement_offer_handle: null,
            requires_update: true,
        };
    }

    return {
        action: 'none',
        replacement_offer_handle: null,
        requires_update: false,
    };
}

async function handleUrlDiscount(data) {
    const offerHandle = parseOfferFromCode(data.value)
        || document.querySelector(SELECTORS.root)?.dataset.marketDefaultOffer
        || null;
    if (!offerHandle) return;
    if (
        window.cartAttributes?._offer_handle
        && util.normalize.text(window.cartAttributes?._offer_handle) === util.normalize.text(offerHandle)
    ) return;

    if (!window.hasInteracted) window.hasInteracted = true;
    startKlaviyoOfferBlocker(offerHandle);

    const updateParams = {
        attributes: {
            _offer_handle: offerHandle,
        }
    }
    const context = "offer:set";
    const requests = parseOfferUpdateInputs(null, updateParams, context);
    await dispatchCartRequests({ requests, context, init: true, resolve: false, previous_offer_handle: window.cartAttributes?._offer_handle ?? null });

    return true;
}

function parseOfferFromCode(code) {
    const normalizedCode = util.normalize.text(code).toLowerCase();
    if (!normalizedCode) return null;

    const offer = DISCOUNT_OFFER_BINDINGS.find((binding) => (
        binding.discount_codes.includes(normalizedCode)
    ));

    return offer?.offer || null;
}

function handleUrlSearchCacheReset(data) {
    if (data.value && !util.transform.boolean(data.value)) return;

    try {
        const keys = Object.keys(window.localStorage || {});
        keys.forEach((key) => {
            if (key.startsWith(LOCAL_STORAGE_KEYS.custom_search_prefix)) {
                window.localStorage.removeItem(key);
            }
        });
    } catch (error) {
        console.warn('[OfferEngine] Unable to clear custom search cache', error);
    }

    return true;
}

async function handleUrlParams() {
    const values = extractUrlParams();
    const handled = [];
    const handlerPromises = [];

    Object.entries(values).forEach(([key, value]) => {
        const handler = URL_PARAM_UTILITIES[key];
        if (handler) {
            // Handler may or may not be async; ensure promise wrapping
            const maybePromise = handler({ key: key, value: value });
            handlerPromises.push(
                maybePromise && typeof maybePromise.then === 'function'
                    ? maybePromise
                    : Promise.resolve(maybePromise)
            );
            handled.push(key);
        }
    });

    await Promise.all(handlerPromises);
    if (handled.includes('reset_offer')) handled.push('offer_reset');
    if (handled.length > 0) clearUrlParams(handled);
    return handled.length > 0;
}

function extractUrlParams() {
    const paramsJson = {};
    const searchParams = new URLSearchParams(window.location.search);
    // Collect all keys from searchParams for inspection/debugging or later use
    const seen = []
    for (const [key, value] of searchParams.entries()) {
        const normalizedKey = key.replace('offer_reset', 'reset_offer').toLowerCase(); // Normalize reset keys for simpler handling
        if (seen.includes(normalizedKey)) continue;
        seen.push(normalizedKey);
        paramsJson[normalizedKey] = value;
    }
    if (paramsJson.offer && paramsJson.reset_offer) delete paramsJson.offer; // Protection against apply + remove weirdness
    if (paramsJson.offer && paramsJson.discount) delete paramsJson.discount;
    return paramsJson;
}

function clearUrlParams(keys) {
    if (keys.length === 0) return;

    const searchParams = new URLSearchParams(window.location.search);
    keys.forEach(key => searchParams.delete(key));
    const newQueryString = searchParams.toString();
    const newUrl = window.location.pathname + (newQueryString ? '?' + newQueryString : '');
    window.history.replaceState({}, '', newUrl);
}

function parseCurrentTs() {
    return Date.now();
}

function startOfferTransitionUi() {
    if (TRANSITION_UI_ACTIVE !== true) TRANSITION_UI_ACTIVE = true;
    offerTransitionDepth += 1;

    const mainContent = document.getElementById('MainContent');
    if (!(mainContent instanceof HTMLElement)) return;

    mainContent.classList.add('offer-transitioning');
}

function startCartLoadingUi() {
    if (TRANSITION_UI_ACTIVE !== true) TRANSITION_UI_ACTIVE = true;

    const cartDrawer = document.querySelector(SELECTORS.cartItemsComponent);
    if (!(cartDrawer instanceof HTMLElement)) return;

    cartDrawer.classList.add('cart-items-disabled');
}

function endOfferTransitionUi() {
    if (TRANSITION_UI_ACTIVE !== true) return;
    TRANSITION_UI_ACTIVE = false;
    offerTransitionDepth = Math.max(offerTransitionDepth - 1, 0);
    if (offerTransitionDepth > 0) return;

    const mainContent = document.getElementById('MainContent');
    if ((mainContent instanceof HTMLElement)) mainContent.classList.remove('offer-transitioning');

    const cartDrawer = document.querySelector(SELECTORS.cartItemsComponent);
    if ((cartDrawer instanceof HTMLElement)) cartDrawer.classList.remove('cart-items-disabled');
}

// CURRENTLY UNUSED BUT LEAVING FOR NOW BECAUSE IT MAY BE RELEVANT IN THE FUTURE
async function checkOfferExpiryAndReset() {
    if (checkIsOfferPage()) return;
    if (!checkOfferExpiredByAge()) return;

    await handleOfferReset();
    return;
}

function checkResetNecessary(requests) {
    if (requests.length === 0) return false;
    if (requests.length > 1) return true;

    const request = requests[0];
    if (request.method !== 'update') return true;
    const payload = request.payload;
    const attributes = payload.attributes || {};

    // Check if we actually need the attr updates
    let attrUpdateRequired = false;
    const currentAttributes = window.cartAttributes || {};
    if (Object.keys(attributes).length > 0) {
        for (const [key, value] of Object.entries(attributes)) {
            const valueMatches = ((value === null && (!currentAttributes[key] || currentAttributes[key] === null))
                || (value !== null && currentAttributes[key] === value)
            );
            if (!valueMatches) {
                attrUpdateRequired = true;
                break;
            }
        }
    };
    // Check if we need discount updates
    const discountUpdateRequired = window.config?.params?.discounts?.length > 0 || false;
    
    return (attrUpdateRequired || discountUpdateRequired) ? true : false;
}

function parseFreeshipMode(mode) {
    if (!mode) return null;
    if (mode === 'Order subtotal amount') return 'amount';
    if (mode === 'Applicable item quantity') return 'quantity';
    return null;
}

function parseFreeshipThreshold(mode, data) {
    if (!mode) return null;
    if (mode === 'amount') {
        const value = data.free_shipping_amount_minimum?.amount || null
        return value ? util.normalize.number(value) : null;
    }
    if (mode === 'quantity') return util.normalize.number(data.free_shipping_quantity_minimum) || null;
    return null;
}

function parseDiscountDisplayContent(discount) {
    if (!discount) return null;

    const collectionTypes = {
        "325582160071": "device",
        "325582192839": "refill",
    }

    let targetText = "item";
    if (discount.applies_to === "Specific collections" && Array.isArray(discount.collection_ids)) {
        const matchedId = discount.collection_ids.find(id => collectionTypes[id]);
        if (matchedId) {
            targetText = collectionTypes[matchedId];
        }
    }

    switch (discount.method) {
        case 'Percentage':
            return {
                amount: `${Math.round(discount.amount)}%`,
                target_text: targetText,
            };
        case 'Fixed amount':
            // formatMoneyDeep never existed - this branch crashed init for any
            // non-percentage discount. Plain USD formatting matches every other
            // hardcoded money display in this file.
            return {
                amount: `$${(Number(discount.amount) || 0).toFixed(0)}`,
                target_text: targetText,
            };
        default:
            return null;
    }
}

function parseJsonFromDrop(drop, fallback = {}) {
    const key = drop.dataset.offerConfig ? util.transform.cssEscape(drop.dataset.offerConfig).replaceAll('-', '_') : null;
    if (!key) return null;
    return {
        key,
        data: util.data.parseJsonScript(drop, fallback),
    }
}

function parseActiveDiscountRate(price, comparePrice) {
    const discountRate = 1 - (price / comparePrice);
    return Math.max(0, Math.min(1, parseFloat(discountRate.toFixed(2))));
}

function parseLiquidJsonArrayContent(values) {
    const out = {}
    values.forEach(value => {
        const key = value[0];
        const val = value[1];
        out[key] = val;
    })
    return out;
}

function parseLiquidCartItems(items = []) {
    const out = [];
    items.forEach(item => {
        const props = parseLiquidJsonArrayContent(item.properties);
        out.push({
            ...item,
            properties: props,
        })
    })
    return out;
}

// /* ———————————————————————————————————————— */
// /* delegated event handlers */
// /* ———————————————————————————————————————— */

// function handleDocumentClick(event) {
//     const target = event.target;
//     if (!(target instanceof Element)) return;

//     for (const [selector, handler] of clickHandlers.entries()) {
//         const matchedTarget = target.closest(selector);
//         if (!matchedTarget) continue;

//         handler(event, matchedTarget);
//         break;
//     }
// }

function checkIsOfferPage() {
    return window.location.pathname.includes(OFFER_PAGE_PATH_FRAGMENT);
}

// NOT CURRENTLY USED, MAY NEED IT
function checkOfferExpiredByAge() {
    const offerHandle = window.cartAttributeOffer ?? null;
    if (!offerHandle) return false;

    const days = readResetWindowDays();
    if (!Number.isFinite(days) || days < 0) return false;

    const appliedMs = readOfferAppliedTimestampMs();
    if (!Number.isFinite(appliedMs)) return false;

    const maxAgeMs = days > 0
        ? days * 24 * 60 * 60 * 1000
        : 60 * 60 * 1000;
    const ageMs = Date.now() - appliedMs;
    const isExpired = ageMs > maxAgeMs;

    if (isExpired) {
        console.warn('[OfferEngine] Offer expired by age window');
    }

    return isExpired;
}

function parseCurrentCart(rawCart = null) {
    if (rawCart) return rawCart;
    if (window.lastCart) return window.lastCart;
    return {
        attributes: window.cartAttributes || {},
        discount_codes: parseCartDiscountCodes(),
        items: parseCartItems(),
        simulated: true
    }
}

function parseCartDiscountCodes() {
    if (window.config?.params?.discounts) {
        return window.config.params.discounts.map((discount) => ({
            code: discount.title?.toLowerCase().trim() || '',
        }));;
    }
    if (window.cartDiscountCodes) return window.cartDiscountCodes;
    if (sessionStorage.getItem(SESSION_KEYS.cart_discounts)) return JSON.parse(sessionStorage.getItem(SESSION_KEYS.cart_discounts));
    return [];
}

function parseCartItems() {
    if (window.lastCart && window.lastCart.items) return window.lastCart.items;
    if (window.config?.params?.cart_items) return window.config.params.cart_items;
    if (window.cartItems) return window.cartItems;
    if (sessionStorage.getItem(SESSION_KEYS.cart_items)) return JSON.parse(sessionStorage.getItem(SESSION_KEYS.cart_items));
    return [];
}

function parseOfferUpdateInputs(rawCart, rawInputs, context = "validate") {
    const currentCart = parseCurrentCart(rawCart);
    const nextConfig = parseNextConfig(currentCart, rawInputs, context);
    const nextCart = util.clone.obj(currentCart);

    if (!nextCart.attributes) nextCart.attributes = {};
    if (!nextConfig.attributes) nextConfig.attributes = {};

    const updateStates = parseCartReconciliationState(nextConfig, nextCart);
    return updateStates.requests;
}

function parseUpdateRequired(current, next) {
    if (!current || !next) return true;

    return Object.entries(next).some(([key, value]) => {
        if (!(key in current)) return true; // If next has a key that current doesn't, update is required

        const currentVal = current[key];
        // Explicitly treat null as a change when on the next side.
        if (value === null && currentVal !== null) return true;
        if (currentVal === null && value !== null) return true;
        if (currentVal !== value) return true;

        return false;
    });
}

function parseNextConfig(cart, rawInputs, context = "validate") {
    // Deep clone window.config?.params or default to empty object
    let nextConfig = window.config?.params 
        ? util.clone.obj(window.config.params)
        : {};
    
    if (!Object.keys(nextConfig).length) throw new Error('[OfferEngine] parseNextConfig error: Config has not been hydrated');
    if (context === 'validate') return nextConfig;

    if (context === 'offer:reset') {
        nextConfig.attributes = {
            ...nextConfig.attributes,
            ...rawInputs.attributes,
        }
        nextConfig = {
            ...nextConfig,
            ...DEFAULT_CONFIG_PARAMS,
        }
        return nextConfig;
    }

    if (context === 'offer:set') {
        const currentCheck = cart.attributes?._offer_handle 
            ? { 
                _offer_handle: cart.attributes._offer_handle,
            } : null;
        const nextCheck = rawInputs.attributes?._offer_handle 
            ? { 
                _offer_handle: rawInputs.attributes._offer_handle,
            } : null;

        if (!parseUpdateRequired(currentCheck, nextCheck) && !parseUpdateRequired(cart.attributes, rawInputs.attributes)) return nextConfig;
        nextConfig.attributes = {
            ...nextConfig.attributes,
            ...rawInputs.attributes,
        }
        return nextConfig;
    }
}

async function dispatchCartRequests(inputs = {}) {
    const {
        requests = [],
        context = "validate",
        init = true,
        cart_loading = false,
        resolve = false,
        previous_offer_handle = null,
        cart = null,
        open_cart = false,
        open_cart_delay = 0,
        deferred_section_ids = [],
    } = inputs;
    if (resolve || !requests.length) {
        await resolveCartUpdate(cart || {}, open_cart, open_cart_delay, deferred_section_ids)
        if (TRANSITION_UI_ACTIVE) endOfferTransitionUi();
        return true;
    }

    if (init && context.includes('offer') && !TRANSITION_UI_ACTIVE) startOfferTransitionUi();
    if (cart_loading) startCartLoadingUi();
    const request = requests[0];
    const sectionPlan = requests.length === 1 ? createCartRequestSectionPlan(context) : null;
    if (sectionPlan) {
        attachSectionsToRequest(request, sectionPlan.bundled);
        startSectionRefreshUi(sectionPlan.all);
    }

    const cartResponse = await cartFetch(request.method, request.payload || {});
    if (!cartResponse || (inputs.validate_response && (cartResponse.errors || cartResponse.status >= 400))) {
        if (TRANSITION_UI_ACTIVE) endOfferTransitionUi();
        return false;
    }

    const seed = {
        ...(inputs.validate_response ? { validate_response: true } : {}),
        requests: requests.length > 1 ? requests.slice(1) : [],
        cart: cartResponse,
        init: false,
        deferred_section_ids: normalizeSectionIds([
            ...deferred_section_ids,
            ...(sectionPlan?.deferred || []),
        ]),
        ...(inputs.open_cart ? { open_cart: true } : {}),
        ...(inputs.open_cart_delay ? { open_cart_delay: open_cart_delay } : {}),
    }

    if (context === 'offer:set') {
        if (!cartResponse.sections) {
            cartResponse.sections = await fetchCartSections(resolveSectionInputs(['offer_config']));
        }

        const validation = handleShadowValidation(cartResponse.sections);
        const configSeed = validation.config || util.clone.obj(window.config?.params || DEFAULT_CONFIG_PARAMS);
        
        if (cartResponse.attributes && Object.keys(cartResponse.attributes).length) {
            configSeed.attributes = {
                ...(configSeed.attributes || {}),
                ...cartResponse.attributes,
            }
        }
        if (!validation.valid || validation.offer_exists !== true) configSeed.attributes._offer_handle = previous_offer_handle || null;
        const seedUpdateStates = parseCartReconciliationState(configSeed, cartResponse);
        seed.requests = seedUpdateStates.requests;
        if (!seed.requests.length) {
            const offerRefreshIds = resolveOfferSetFollowupSectionIds(cartResponse.sections);
            startSectionRefreshUi(offerRefreshIds);
            seed.deferred_section_ids = normalizeSectionIds([
                ...seed.deferred_section_ids,
                ...offerRefreshIds,
            ]);
        }
    }

    if (!seed.requests.length) { 
        seed.resolve = true
    };
    
    return await dispatchCartRequests(seed);

}

async function resolveCartUpdate(cart, toggleOpen = false, delay = 0, deferredSectionIds = []) {
    const emptyState = cart && cart.items && cart.items.length === 0 ? true : !cart ? null : false;
    let sections = cart?.sections || null;
    let deferredIds = normalizeSectionIds(deferredSectionIds);

    if (!sections) {
        const sectionPlan = createCartRequestSectionPlan();
        startSectionRefreshUi(sectionPlan.all);
        sections = await fetchCartSections(sectionPlan.bundled);
        deferredIds = normalizeSectionIds([
            ...deferredIds,
            ...sectionPlan.deferred,
        ]);
    }

    handleCartDomUpdates(sections, emptyState, Object.keys(sections || {}));
    await fetchDeferredCartSections(deferredIds);
    if (toggleOpen) {
        setTimeout(() => {
            openCartDrawer();
        }, delay);
    }
    const confirmedCart = cart && cart.token ? cart : null;
    await handleCartResponse(confirmedCart);
    return true;
}

function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!(cartDrawer instanceof DialogComponent)) return;

    cartDrawer.showDialog();
}

function handleCartDomUpdates(sections, emptyState, expectedSectionIds = []) {
    if (!sections) {
        console.warn('[OfferEngine] Cart DOM update skipped: missing sections payload');
        endSectionRefreshUi(expectedSectionIds);
        return;
    }
    const ariaLabel = emptyState ? 'cart-drawer-heading-empty' : 'cart-drawer-heading';
    const dialogEl = document.querySelector('dialog.cart-drawer__dialog');
    if (dialogEl && emptyState !== null) {
        dialogEl.setAttribute('aria-label', ariaLabel);
        if (!emptyState) dialogEl.classList.remove('cart-drawer--empty');
        if (emptyState) {
            dialogEl.classList.add('empty--transition')
            dialogEl.classList.add('cart-drawer--empty');
            setTimeout(() => {
                dialogEl.classList.remove('empty--transition');
            }, 350);
        }
    }
    Object.entries(sections).forEach(([key, value]) => {
        const id = `shopify-section-${key}`;
        const parsedSection = value ? queryShadowEl(value, `#${id}`) : null;
        const pageSection = document.getElementById(id);

        const type = parseRenderedSectionType(key, parsedSection);
        if (!type) {
            endSectionRefreshUi([key]);
            return;
        }

        const resolver = CART_UPDATE_SECTION_RESOLVERS[type];
        if (!resolver) {
            endSectionRefreshUi([key]);
            return;
        }
        resolver(pageSection, parsedSection);
        endSectionRefreshUi([key]);
    })

    const returnedSectionIds = Object.keys(sections);
    const missingSectionIds = expectedSectionIds.filter((sectionId) => (
        !returnedSectionIds.includes(sectionId)
    ));
    endSectionRefreshUi(missingSectionIds);
}

function parseRenderedSectionType(key, parsedSection) {
    if (!key && !parsedSection) return null;
    if (parsedSection?.querySelector(':scope > cart-items-component[data-section-id]')) return 'cart-page';
    if (key) {
        if (key.includes('offer-engine-json')) return 'offer-engine-json';
        if (key.includes('announcement')) return 'announcement-bar';
        if (key.includes('header_section')) return 'header';
        if (key.includes('product_recommendations')) return 'product-recommendations';
        
        return 'pricing'
    }
    if (parsedSection) {
        if (queryShadowEl(parsedSection, '[data-content="product-prices"]')) return 'pricing';
    }
    return null;
}

function handleOfferJsonReplacement(target, parsed) {
    if (!target || !parsed) return;

    if (
        target.innerHTML !== parsed.innerHTML
    ) {
        target.innerHTML = parsed.innerHTML;
    }
    const targetDisplayMap = target.querySelector('[data-offer-display-map]')?.textContent.trim() ?? null;
    const parsedDisplayMap = parsed.querySelector('[data-offer-display-map]')?.textContent.trim() ?? null;

    handleDisplayMapUpdates(targetDisplayMap, parsedDisplayMap);
}

function handleDisplayMapUpdates(original, next) {
    const originalSplit = original ? original.split('=') : null;
    const nextSplit = next ? next.split('=') : null;

    const originalAttr = originalSplit?.[0] || null;
    const nextAttr = nextSplit?.[0] || null;
    const nextValue = nextSplit?.[1]?.replaceAll('"', '').trim() || null;
    
    if (originalAttr) MAIN_EL.removeAttribute(originalAttr);
    if (nextAttr && nextValue) MAIN_EL.setAttribute(nextAttr, nextValue);
}

function updateMainPreorderState(isActive) {
    if (!MAIN_EL) return;

    if (isActive) {
        MAIN_EL.setAttribute('data-preorder-active', 'true');
        return;
    }

    MAIN_EL.removeAttribute('data-preorder-active');
}

function handleAnnouncementCartUpdates(target, parsed) {
    if (!target || !parsed) return;

    const targetSlides = target.querySelectorAll('slideshow-slide');
    const parsedSlides = parsed.querySelectorAll('slideshow-slide');

    if (targetSlides.length !== parsedSlides.length) { 
        target.replaceWith(parsed);
        return;
    }

    for (let i = 0; i < targetSlides.length; i++) {
        const targetSlide = targetSlides[i];
        const parsedSlide = parsedSlides[i];
        
        if (targetSlide.outerHTML !== parsedSlide.outerHTML) {
            targetSlide.replaceWith(parsedSlide);
            break;
        }
    }

    return;
}

function handleHeaderCartUpdates(target, parsed) {
    // const selectors = ['.cart-bubble', '.cart-threshold-progress', '.cart-items__wrapper', '.cart-drawer-gifts', '.cart-drawer__summary']

    if (!target || !parsed || target.innerHTML === parsed.innerHTML) return;

    const targetCartDrawer = target.querySelector('cart-drawer-component');
    const parsedCartDrawer = parsed.querySelector('cart-drawer-component');
    if (!targetCartDrawer || !parsedCartDrawer || targetCartDrawer.outerHTML === parsedCartDrawer.outerHTML) return;

    const targetIcon = targetCartDrawer.querySelector('button[data-testid="cart-drawer-trigger"]');
    const parsedIcon = parsedCartDrawer.querySelector('button[data-testid="cart-drawer-trigger"]');
    if (targetIcon && parsedIcon && targetIcon.outerHTML !== parsedIcon.outerHTML) {
        targetIcon.replaceWith(parsedIcon);
    }

    const targetDrawer = targetCartDrawer.querySelector('.cart-drawer__inner');
    const parsedDrawer = parsedCartDrawer.querySelector('.cart-drawer__inner');
    if (targetDrawer && parsedDrawer && targetDrawer.innerHTML !== parsedDrawer.innerHTML) {
        targetDrawer.innerHTML = parsedDrawer.innerHTML;
    }

    return;
}

function handleCartPageUpdates(target, parsed) {
    if (!target || !parsed || target.innerHTML === parsed.innerHTML) return;

    const preorderToggle = parsed.querySelector(SELECTORS.cartPreorderToggle);
    if (preorderToggle && target.querySelector(SELECTORS.cartPreorderToggle)?.disabled) {
        preorderToggle.disabled = true;
    }
    morphSection(target.id.replace('shopify-section-', ''), parsed.outerHTML);
}

function handleSectionPricingUpdates(target, parsed) {
    if (!target || !parsed || target.innerHTML === parsed.innerHTML) return;

    const type = parsed.querySelector('product-card') ? 'card' : 'price';

    const targetEls = type === 'card' ? target.querySelectorAll('product-card') : target.querySelectorAll(SELECTORS.priceWrapper);
    const parsedEls = type === 'card' ? parsed.querySelectorAll('product-card') : parsed.querySelectorAll(SELECTORS.priceWrapper);
    
    if (targetEls.length !== parsedEls.length) {
        console.error ('The number of displayed price elements does not match.')
        return;
    }

    for (let i = 0; i < targetEls.length; i++) {
        const targetEl = targetEls[i];
        const parsedEl = parsedEls[i];
        if (targetEl.outerHTML !== parsedEl.outerHTML) {
            targetEl.replaceWith(parsedEl);
        }
    }   

    handleProductFormOfferUiUpdates(target, parsed);
}

function handleProductFormOfferUiUpdates(target, parsed) {
    const targetForms = Array.from(target.querySelectorAll('product-form-component'));
    const parsedForms = Array.from(parsed.querySelectorAll('product-form-component'));
    if (!targetForms.length || !parsedForms.length) return;

    targetForms.forEach((targetForm, index) => {
        const parsedForm = findMatchingProductForm(targetForm, parsedForms, index);
        if (!parsedForm) return;

        updatePreorderToggle(targetForm, parsedForm);
        updateAddStateInputs(targetForm, parsedForm);
        updateGiftDisplay(targetForm, parsedForm);
    });
}

function findMatchingProductForm(targetForm, parsedForms, index) {
    const productId = targetForm?.dataset?.productId || '';
    const variantId = targetForm?.querySelector('input[name="id"]')?.value || '';

    const matchingForm = parsedForms.find((form) => {
        if (productId && form?.dataset?.productId !== productId) return false;

        const parsedVariantId = form.querySelector('input[name="id"]')?.value || '';
        return !variantId || !parsedVariantId || parsedVariantId === variantId;
    });

    if (matchingForm) return matchingForm;
    if (productId || variantId) return null;

    return parsedForms[index] || null;
}

function updatePreorderToggle(targetForm, parsedForm) {
    const targetToggle = targetForm.querySelector('[data-preorder-toggle]');
    const parsedToggle = parsedForm.querySelector('[data-preorder-toggle]');
    const buttons = targetForm.querySelector('.product-form-buttons');

    updateOfferUiElement(targetToggle, parsedToggle, () => buttons?.firstElementChild || null, 'beforebegin');
}

function updateAddStateInputs(targetForm, parsedForm) {
    const targetInputs = targetForm.querySelector('[data-content="add-state-inputs"]');
    const parsedInputs = parsedForm.querySelector('[data-content="add-state-inputs"]');
    const addToCart = targetForm.querySelector('add-to-cart-component');
    const addToCartWrapper = addToCart?.closest('span') || addToCart;

    updateOfferUiElement(targetInputs, parsedInputs, () => addToCartWrapper || null, 'beforebegin');
}

function updateGiftDisplay(targetForm, parsedForm) {
    const targetDisplay = targetForm.querySelector('[data-content="gift-display"][data-location="buy-buttons"]');
    const parsedDisplay = parsedForm.querySelector('[data-content="gift-display"][data-location="buy-buttons"]');
    const targetWrapper = getGiftDisplayWrapper(targetDisplay);
    const parsedWrapper = getGiftDisplayWrapper(parsedDisplay);
    const buttons = targetForm.querySelector('.product-form-buttons');
    const acceleratedCheckout = targetForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');

    updateOfferUiElement(
        targetWrapper,
        parsedWrapper,
        () => acceleratedCheckout || buttons?.lastElementChild || null,
        'afterend'
    );
}

function getGiftDisplayWrapper(display) {
    if (!display) return null;

    return display.parentElement?.classList.contains('mt1') ? display.parentElement : display;
}

function updateOfferUiElement(targetEl, parsedEl, getInsertReference, insertPosition = 'beforebegin') {
    if (targetEl && parsedEl) {
        if (targetEl.outerHTML !== parsedEl.outerHTML) targetEl.replaceWith(parsedEl.cloneNode(true));
        return;
    }

    if (targetEl && !parsedEl) {
        targetEl.remove();
        return;
    }

    if (!targetEl && parsedEl) {
        const reference = getInsertReference?.();
        if (reference) reference.insertAdjacentElement(insertPosition, parsedEl.cloneNode(true));
    }
}

function handleDynamicRecCartUpdates(target, parsed) {
    document.dispatchEvent(new CustomEvent(OFFER_CHANGE_EVENT, { bubbles: true}));
}

function parseCartReconciliationState(config, cart) {
    const attrsState = parseAttrsState(config, cart);
    const discountsState = parseDiscountsState(config, cart);
    const preorderState = parsePreorderState(config, cart, discountsState.active_discounts);
    const preorderChanges = [];
    appendPreorderStateChanges(preorderChanges, preorderState.line_changes);
    const priceOverrideState = parsePriceOverrideState(config, {
        ...cart,
        items: recompileNextCart(cart.items || [], preorderChanges),
    }, discountsState.active_discounts);
    const giftsState = parseGiftsState(config, cart);

    const plan = parseCartStateMutationPlan(
        config,
        attrsState,
        discountsState,
        preorderState,
        priceOverrideState,
        giftsState,
        cart
    );
    const requests = orchestrateRequests(plan);

    return {
        plan,
        requests,
        type_states: {
            attrs: attrsState.requires_update || false,
            discounts: discountsState.requires_update || false,
            preorder: preorderState.requires_update || false,
            price_overrides: priceOverrideState.requires_update || false,
            gifts: giftsState.requires_update || false,
        }
    };
}

function parseCartStateMutationPlan(
    config = {},
    attrsState = {},
    discountsState = {},
    preorderState = {},
    priceOverrideState = {},
    giftsState = {},
    cart = {}
) {
    const requestsByType = createCartMutationRequestBuckets();
    const attributes = {};
    const discount = discountsState.requires_update
        ? discountsState.discount_string || ''
        : undefined;

    if (attrsState.requires_update) {
        appendCartStateAttributes(attributes, attrsState.attributes);
    }

    if (preorderState.requires_update) {
        appendPreorderStateChanges(requestsByType.changes, preorderState.line_changes);
        appendCartStateAttributes(attributes, preorderState.attributes);
    }

    if (priceOverrideState.requires_update) {
        mergeManagedLineChanges(requestsByType, priceOverrideState.line_changes);
    }

    if (giftsState.requires_update) {
        appendGiftStateUpdates(requestsByType.updates, giftsState.updates);
        if (Array.isArray(giftsState.additions)) requestsByType.adds.push(...giftsState.additions);
    }

    const projected = projectCartMutationState(
        Array.isArray(cart.items) ? cart.items : [],
        createCartMutationSimulationMods(requestsByType)
    );

    if (checkShouldClearPreorderAttr(cart, projected.nextItems)) {
        attributes._preorder = null;
    }

    return {
        adds: requestsByType.adds,
        changes: requestsByType.changes,
        updates: requestsByType.updates,
        attributes,
        discount,
        cart,
        discounts: config.discounts || [],
    };
}

function handlePendingGiftRemoval() {
    const cartGiftDisplay = document.querySelector(SELECTORS.cartGiftDisplay);
    if (!cartGiftDisplay) return;
    cartGiftDisplay.classList.add('hide--transition');
}

function appendCartStateAttributes(target = {}, attributes = {}) {
    if (!attributes || typeof attributes !== 'object') return;
    Object.assign(target, attributes);
}

function appendPreorderStateChanges(target = [], lineChanges = []) {
    if (!Array.isArray(lineChanges)) return;

    lineChanges.forEach(change => {
        const key = change?.key || change?.id;
        if (!key) return;

        target.push({
            type: 'change',
            body: {
                key,
                ...(change.variant_id !== undefined ? { variant_id: change.variant_id } : {}),
                ...(change.quantity !== undefined ? { quantity: change.quantity } : {}),
                ...(change.properties !== undefined ? { properties: change.properties } : {}),
                ...(change.selling_plan !== undefined ? { selling_plan: change.selling_plan } : {}),
            },
        });
    });
}

function appendGiftStateUpdates(target = [], updates = {}) {
    if (!updates || typeof updates !== 'object') return;

    Object.entries(updates).forEach(([key, quantity]) => {
        target.push({
            type: 'update',
            body: {
                key,
                quantity,
            },
        });
    });
}

// Ensures that dependent attributes are validated and updated as needed. 
function parseAttrsState(config, cart) {
    const out = {
        requires_update: false,
        attributes: {},
    };

    if ((!cart.attributes || !Object.keys(cart.attributes).length)
        && (!config.attributes || !Object.keys(config.attributes).length)
    ) return out;

    if (config && config.attributes && Object.keys(config.attributes).length > 0) {
        Object.entries(config.attributes).forEach(([key, value]) => {
            if (!cart.attributes?.[key] || cart.attributes[key] !== value) {
                out.requires_update = true;
                out.attributes[key] = value;
            }
        });
    }
    // LOOK AT OFFER FOR ATTR BOUND DATA, COMPARE, AND ADD TO OUT IF NECESSARY
    Object.entries(OFFER_ATTR_BINDINGS).forEach(([key, value]) => {
        if (config?.offer?.hasOwnProperty(key) && config?.offer?.[key] !== null
            && (!cart?.attributes?.[value] || cart?.attributes?.[value] !== config?.offer?.[key])
        ) {
            out.requires_update = true;
            out.attributes[value] = config?.offer?.[key];
        }
    });
    // Loop through existing cart attributes to ensure dependency requirements are correct.
    // For Example: If a cart has _offer_handle but not _offer_applied_ts, then we need to set _offer_applied_ts.
    Object.entries(cart.attributes).forEach(([key, value]) => {
        if (CART_ATTR_DEPENDENCIES[key]) {
            CART_ATTR_DEPENDENCIES[key].forEach((dependency) => {
                if (!cart.attributes[dependency.key] && !config.attributes.hasOwnProperty(dependency.key)) {
                    out.requires_update = true;
                    out.attributes[dependency.key] = dependency.handler();
                }
            });
        }
    });

    return out;
}

function parseChangePayloadBody(change, requestType = 'change') {
    if (requestType === 'change') {
        const payload = {
            id: change.key,
            ...(change.quantity !== undefined ? { quantity: change.quantity } : {}),
            ...(change.properties !== undefined ? { properties: change.properties } : {}),
            ...(change.selling_plan !== undefined ? { selling_plan: change.selling_plan } : {}),
        };
        return payload;
    }
    
    if (requestType === 'add') {
        const variantId = util.normalize.number(change.variant_id) || util.normalize.number(change.key.split(':')[0]);
        return {
            id: variantId,
            quantity: change.quantity,
            properties: change.properties || {},
            ...(change.selling_plan !== undefined ? { selling_plan: change.selling_plan } : {}),
        };
    }

    throw new Error(`[OfferEngine.parseChangePayloadBody] Unsupported requestType: ${requestType}`);
}

/* ------------------------------------------------------------------------ */

/* GIFT STATE PARSING & HELPERS */

/* ------------------------------------------------------------------------ */
function parseGiftsState(config, cart) {
    const cartItems = cart?.items ? cart.items : parseCartItems();
    // Prefer the attributes of the cart being reconciled; the window snapshot only
    // refreshes at the end of a dispatch chain and can be stale mid-chain/cross-tab.
    const giftSubAttributes = cart?.attributes || window.cartAttributes || {};

    const nonGiftItems = applyNonGiftItemFilter(cartItems);
    const existingGiftItems = applyGiftItemFilter(cartItems);

    const out = {}

    const giftUpdates = {};
    const giftAdditions = [];
    const matchedGiftKeys = [];
    const addGiftTempKeys = [];
    // Handle case where there are no gift sets
    if (!config.gift_sets?.length) {
        out.requires_update = existingGiftItems.length > 0;
        if (!existingGiftItems.length) return out; // If no gift sets and no gifts, no action needed.
        // Otherwise, remove the existing gifts
        out.updates = {}
        existingGiftItems.forEach(item => {
            out.updates[item.key] = 0;
        });
        return out;
    }
    // If there are gift sets, they need to be parse for update / addition.
    config.gift_sets.forEach((giftSet) => {
        const qualifyingQuantity = parseApplicableQuantityInCart(nonGiftItems, giftSet.qualifier_variant_ids);
        const applicableGifts = parseApplicableGifts(config.gift_items, giftSet, qualifyingQuantity);
        applicableGifts.forEach((gift) => {
            if (!gift  || !gift.variant_ids || !gift.variant_ids.length) return;
            // Selectable gifts can span multiple colors. Reconcile their total,
            // retaining earlier configured options when the entitlement shrinks.
            if (gift.variant_ids.length > 1) {
                const lines = existingGiftItems.filter(item => (
                    checkGiftLineMatches(item, gift) && !matchedGiftKeys.includes(item.key)
                )).sort((a, b) => a.variant_id - b.variant_id || a.key.localeCompare(b.key));
                const allocations = parseGiftVariantQuantities(gift, qualifyingQuantity, lines);
                const remaining = new Map(allocations.map(item => [item.id, item.quantity]));
                lines.forEach(item => {
                    matchedGiftKeys.push(item.key);
                    const quantity = Math.min(item.quantity, remaining.get(item.variant_id) || 0);
                    remaining.set(item.variant_id, (remaining.get(item.variant_id) || 0) - quantity);
                    if (quantity !== item.quantity) giftUpdates[item.key] = quantity;
                });
                allocations.forEach(selection => {
                    const missing = remaining.get(selection.id) || 0;
                    if (!missing) return;
                    const existing = lines.find(item => item.variant_id === selection.id);
                    if (existing) {
                        giftUpdates[existing.key] = (giftUpdates[existing.key] ?? existing.quantity) + missing;
                    } else {
                        const plan = parseGiftSubscriptionPlanId(config, gift, giftSubAttributes, selection.id);
                        giftAdditions.push({ id: selection.id, quantity: missing,
                            properties: { _is_gift: 'true', _gift_item_id: String(gift.id),
                                _gift_set_id: String(gift.gift_set_id) },
                            ...(plan ? { selling_plan: plan } : {}),
                        });
                    }
                });
                return;
            }
            const existingInCart = existingGiftItems.find(item => gift.variant_ids.includes(item.variant_id) && !matchedGiftKeys.includes(item.key));
            if (existingInCart) {
                // If it already exists in the cart, validate / adjust quantity as needed
                matchedGiftKeys.push(existingInCart.key);
                const giftValidation = validateExistingGiftItem(existingInCart, gift, qualifyingQuantity);
                if (!giftValidation.valid) {
                    giftUpdates[giftValidation.updates.key] = giftValidation.updates.quantity;
                }
            } else {
                // If it doesn't exist in the cart, build an add payload
                const addGiftTempKey = giftSet.id + ":" + gift.variant_ids[0];
                if (!addGiftTempKeys.includes(addGiftTempKey)) {
                    addGiftTempKeys.push(addGiftTempKey);
                    const giftSubPlanId = parseGiftSubscriptionPlanId(config, gift, giftSubAttributes);
                    giftAdditions.push({
                        id: gift.variant_ids[0],
                        quantity: parseGiftItemQuantity(qualifyingQuantity, gift),
                        properties: { _is_gift: 'true' },
                        ...(giftSubPlanId ? { selling_plan: giftSubPlanId } : {}),
                    });
                }
            }
        });
    });

    const unmatchedExisting = existingGiftItems.filter(item => !matchedGiftKeys.includes(item.key));
    if (unmatchedExisting.length > 0) {
        unmatchedExisting.forEach(item => {
            giftUpdates[item.key] = 0;
        });
    }

    if (Object.keys(giftUpdates).length > 0) out.updates = giftUpdates;
    if (giftAdditions.length > 0) out.additions = giftAdditions;
    out.requires_update = Object.keys(giftUpdates).length > 0 || giftAdditions.length > 0;
    return out;
}

function parseApplicableGifts(giftItems, giftSet, qualifyingQuantity) {
    return giftItems.filter(item => item.gift_set_id === giftSet.id && qualifyingQuantity >= item.qualifier_threshold);
}

/** Resolve the gift's qualifier scope without counting gifts or unrelated upsells. */
function parseGiftQualifyingQuantity(gift, config, items = []) {
    const giftSet = (config.gift_sets || []).find(set => String(set.id) === String(gift.gift_set_id));
    return giftSet ? parseApplicableQuantityInCart(applyNonGiftItemFilter(items), giftSet.qualifier_variant_ids) : 0;
}

/**
 * Allocate a gift across configured variants. Earlier variant IDs survive a
 * reduced allotment; unselected entitlement uses the first selected color.
 * @param {object} gift - Normalized gift item rules.
 * @param {number} qualifyingQuantity
 * @param {object[]} selections - Variant/quantity pairs, including cart lines.
 * @param {boolean} fillRemainder - False while editing optional quantities.
 * @returns {{id: number, quantity: number}[]}
 */
function parseGiftVariantQuantities(gift, qualifyingQuantity, selections = [], fillRemainder = true) {
    const threshold = Math.max(1, Number(gift.qualifier_threshold) || 1);
    if (qualifyingQuantity < threshold) return [];
    const ids = [...new Set((gift.variant_ids || []).map(Number).filter(Boolean))].sort((a, b) => a - b);
    let remaining = parseGiftItemQuantity(qualifyingQuantity, { ...gift, qualifier_threshold: threshold });
    const quantities = new Map();
    selections.forEach(item => {
        const id = Number(item.variant_id || item.id);
        const quantity = Math.max(0, Math.floor(Number(item.quantity) || 0));
        if (ids.includes(id)) quantities.set(id, (quantities.get(id) || 0) + quantity);
    });
    const result = [];
    ids.forEach(id => {
        const quantity = Math.min(quantities.get(id) || 0, remaining);
        if (quantity > 0) result.push({ id, quantity });
        remaining -= quantity;
    });
    if (fillRemainder && remaining > 0 && ids.length) {
        if (result.length) result[0].quantity += remaining;
        else result.push({ id: ids[0], quantity: remaining });
    }
    return result;
}

function checkGiftLineMatches(item, gift) {
    if (!parseIsGift(item) || !gift.variant_ids.includes(Number(item.variant_id))) return false;
    const properties = item.properties || {};
    return (!properties._gift_item_id || String(properties._gift_item_id) === String(gift.id))
        && (!properties._gift_set_id || String(properties._gift_set_id) === String(gift.gift_set_id));
}

function parseGiftOptionRules(root) {
    return {
        id: Number(root.dataset.giftId), gift_set_id: Number(root.dataset.giftSetId),
        qualifier_threshold: Math.max(1, Number(root.dataset.giftThreshold) || 1),
        additional_qualifier_threshold: Number(root.dataset.giftAdditionalThreshold) || undefined,
        quantity: Number(root.dataset.giftInitialQuantity) || undefined,
        additional_quantity: Number(root.dataset.giftAdditionalQuantity) || undefined,
        allow_multiple: root.dataset.giftStackable === 'true',
        max_allowed: Number(root.dataset.giftMax) || undefined,
        variant_ids: [...root.querySelectorAll('[data-gift-option]')].map(el => Number(el.dataset.giftOption)),
    };
}

/** Read shared Liquid options without including gift quantities in paid selection. */
function parseGiftOptionSelections(root) {
    return [...root.querySelectorAll('[data-gift-option]')].map(option => ({
        id: Number(option.dataset.giftOption),
        quantity: Number(option.querySelector('[data-gift-quantity]').value) || 0,
    }));
}

/** Update both offer and cart gift pickers using the same allotment rules. */
function updateGiftVariantOptions(root, qualifyingQuantity, selections = parseGiftOptionSelections(root)) {
    const gift = parseGiftOptionRules(root);
    const allotment = qualifyingQuantity >= gift.qualifier_threshold
        ? parseGiftItemQuantity(qualifyingQuantity, gift) : 0;
    const allocations = parseGiftVariantQuantities(gift, qualifyingQuantity, selections, allotment === 1);
    const quantities = new Map(allocations.map(item => [item.id, item.quantity]));
    const selected = allocations.reduce((sum, item) => sum + item.quantity, 0);
    root.hidden = allotment < 1;
    root.dataset.state = allotment > 1 ? 'multiple' : 'single';
    root.dataset.stateQualifyingQuantity = String(qualifyingQuantity);
    root.querySelector('[data-content="gift-selection-progress"]').textContent = allotment > 1
        ? `${selected} of ${allotment} gifts selected. Unselected gifts use your first selected color.` : '';
    root.querySelectorAll('[data-gift-option]').forEach(option => {
        const quantity = quantities.get(Number(option.dataset.giftOption)) || 0;
        const input = option.querySelector('[data-gift-quantity]');
        const remaining = Math.max(0, allotment - selected);
        input.value = String(quantity);
        // This picker edits an absolute gift allocation, not an additional PDP quantity.
        input.setAttribute('data-cart-quantity', '0');
        if (input.dataset.stateInventoryMax === undefined) input.dataset.stateInventoryMax = input.getAttribute('max') || '';
        const inventoryMax = input.dataset.stateInventoryMax === '' ? Infinity : Number(input.dataset.stateInventoryMax);
        input.max = String(Math.min(quantity + remaining, inventoryMax));
        option.querySelector('[data-gift-quantity-group]').dataset.state = quantity > 0 ? 'selected' : 'empty';
        option.querySelector('[data-action="gift:select"]').checked = quantity > 0;
        option.querySelector('[data-action="gift:add"]').disabled = remaining === 0;
        option.querySelector('button[name="plus"]').disabled = remaining === 0 || quantity >= Number(input.max);
    });
}

function handleGiftVariantSelect(event, el) {
    const root = el.closest('[data-gift-variant-options]');
    if (!root) return;
    updateGiftVariantOptions(root, Number(root.dataset.stateQualifyingQuantity), [{ id: Number(el.value), quantity: 1 }]);
}

function handleGiftVariantAdd(event, el) {
    const input = el.closest('[data-gift-option]')?.querySelector('[data-gift-quantity]');
    if (!input || el.disabled) return;
    input.value = '1';
    handleGiftVariantQuantity(event, input);
}

function handleGiftVariantQuantity(event, el) {
    const root = el.closest('[data-gift-variant-options]');
    if (!root) return;
    const input = event.target.closest('[data-gift-option]')?.querySelector('[data-gift-quantity]');
    if (input) input.value = String(Math.min(Math.max(0, Math.floor(Number(input.value) || 0)), Number(input.max)));
    updateGiftVariantOptions(root, Number(root.dataset.stateQualifyingQuantity));
}

async function handleCartGiftEdit(event, el) {
    event.preventDefault();
    if (isGiftEditPending || el.disabled) return;
    const editor = el.parentElement.querySelector('[data-cart-gift-editor]');
    const root = editor?.querySelector('[data-gift-variant-options]');
    if (!root) return;
    el.disabled = true;
    let cart;
    let config;
    try {
        cart = await cartFetch('get', {});
        // Offer pages intentionally keep their page offer separate from the
        // cart configuration. Read the cart's own existing JSON section here.
        config = checkIsOfferPage()
            ? handleShadowValidation(await fetchCartSections(resolveSectionInputs(['offer_config']))).config
            : window.config?.params;
    } finally {
        el.disabled = false;
    }
    if (!cart?.token || !config) return;
    const rules = parseGiftOptionRules(root);
    const gift = (config.gift_items || []).find(item => Number(item.id) === rules.id);
    if (!gift) return;
    const quantity = parseGiftQualifyingQuantity(gift, config, cart.items);
    if (quantity < gift.qualifier_threshold) return;
    updateGiftVariantOptions(root, quantity, cart.items.filter(item => checkGiftLineMatches(item, gift)));
    const dialog = editor.querySelector('dialog');
    const colorContext = el.closest('dialog') || el.closest('[class*="color-"]');
    dialog.className = `${dialog.className.split(' color-')[0]} color-${colorContext?.className.match(/\bcolor-([\w-]+)/)?.[1] || 'scheme-1'}`;
    giftEditorSessions.set(editor, { opener: el, parent: editor.parentElement,
        nextSibling: editor.nextSibling, scrollTop: document.body.style.top,
        outerDialog: el.closest('dialog'), offerHandle: cart.attributes?._offer_handle, config });
    document.body.append(editor);
    editor.querySelector('[data-content="gift-edit-error"]').hidden = true;
    editor.showDialog();
}

function handleCartGiftCancel(event, el) {
    if (isGiftEditPending) return;
    el.closest('[data-cart-gift-editor]')?.closeDialog();
}

function handleCartGiftEditorClose(event, editor) {
    const session = giftEditorSessions.get(editor);
    if (!session) return;
    // Native dialog closes release body locking. Preserve the still-open drawer.
    if (session.outerDialog?.open) {
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = session.scrollTop;
    }
    if (session.parent.isConnected) session.parent.insertBefore(editor,
        session.nextSibling?.parentElement === session.parent ? session.nextSibling : null);
    else editor.remove();
    session.opener.isConnected && session.opener.focus({ preventScroll: true });
    giftEditorSessions.delete(editor);
}

async function handleCartGiftConfirm(event, el) {
    if (isGiftEditPending) return;
    const editor = el.closest('[data-cart-gift-editor]');
    const root = editor.querySelector('[data-gift-variant-options]');
    const session = giftEditorSessions.get(editor);
    if (!session) return;
    const errorLabel = editor.querySelector('[data-content="gift-edit-error"]');
    let originalGiftLines = [];
    let replacementAdded = false;
    isGiftEditPending = true;
    editor.querySelectorAll('button').forEach(button => { button.disabled = true; });
    try {
        const cart = await cartFetch('get', {});
        if (!cart?.token || cart.attributes?._offer_handle !== session.offerHandle) throw new Error('Your offer changed. Please reopen the gift options.');
        const config = session.config || window.config?.params || {};
        const gift = (config.gift_items || []).find(item => Number(item.id) === Number(root.dataset.giftId));
        if (!gift) throw new Error('This gift is no longer available.');
        const quantity = parseGiftQualifyingQuantity(gift, config, cart.items);
        if (quantity < gift.qualifier_threshold) throw new Error('This gift is no longer unlocked.');
        const selections = parseGiftVariantQuantities(gift, quantity, parseGiftOptionSelections(root));
        const lines = cart.items.filter(item => checkGiftLineMatches(item, gift));
        originalGiftLines = lines;
        const source = lines[0];
        if (!source) throw new Error('Your cart changed. Please reopen the gift options.');
        const sourcePlan = source.selling_plan_allocation?.selling_plan?.id;
        const additions = [];
        selections.forEach(selection => {
            const existing = lines.find(item => Number(item.variant_id) === selection.id);
            if (existing) return;
            if (!checkGiftVariantAvailable(config.gift_item_products, selection.id)) throw new Error('That gift option is unavailable. Please choose another color.');
            if (sourcePlan) {
                const variant = config.gift_item_products.flatMap(product => product.variants || []).find(item => Number(item.id) === selection.id);
                if (!variant?.selling_plan_allocations?.some(plan => Number(plan.selling_plan_id) === Number(sourcePlan))) throw new Error('That color does not support your current subscription. Please choose another color.');
            }
            additions.push({ id: selection.id, quantity: selection.quantity,
                properties: { ...source.properties, _gift_item_id: String(gift.id), _gift_set_id: String(gift.gift_set_id) },
                ...(sourcePlan ? { selling_plan: sourcePlan } : {}),
            });
        });
        // Add first so an unavailable option cannot remove the original gift.
        // Shopify may change line keys when discounts change: read the current
        // keys after adding, then refresh only once the replacement is complete.
        let currentCart = cart;
        if (additions.length) {
            const added = await cartFetch('add', { items: additions });
            if (!added || added.errors || added.status >= 400) throw new Error('The gift could not be added. Please choose another color.');
            replacementAdded = true;
            currentCart = await cartFetch('get', {});
            if (!currentCart?.token) throw new Error('Unable to confirm the gift update. Please reopen your cart.');
        }
        if (currentCart.attributes?._offer_handle !== session.offerHandle
            || parseGiftQualifyingQuantity(gift, config, currentCart.items) !== quantity) {
            throw new Error('Your cart changed. Please reopen the gift options.');
        }
        const remaining = new Map(selections.map(item => [item.id, item.quantity]));
        const changed = {};
        currentCart.items.filter(item => checkGiftLineMatches(item, gift)).forEach(item => {
            const target = remaining.get(item.variant_id) || 0;
            remaining.set(item.variant_id, 0);
            if (target !== item.quantity) changed[item.key] = target;
        });
        const requests = Object.keys(changed).length ? [{ method: 'update', payload: { updates: changed } }] : [];
        const success = await dispatchCartRequests({ requests, cart: currentCart, context: 'gift:edit', validate_response: true });
        if (!success) throw new Error('The gift could not be updated. Please try again.');
        await editor.closeDialog();
    } catch (error) {
        // If the second mutation fails, restore the original allocation using
        // fresh line keys rather than leaving an extra replacement gift behind.
        if (replacementAdded) {
            try {
                const currentCart = await cartFetch('get', {});
                if (!currentCart?.token) throw new Error('Cart unavailable');
                if (currentCart.attributes?._offer_handle === session.offerHandle) {
                    const rules = parseGiftOptionRules(root);
                    const quantity = parseGiftQualifyingQuantity(rules, session.config || window.config?.params || {}, currentCart.items);
                    const original = new Map(parseGiftVariantQuantities(rules, quantity, originalGiftLines)
                        .map(item => [item.id, item.quantity]));
                    const updates = {};
                    currentCart.items.filter(item => checkGiftLineMatches(item, rules)).forEach(item => {
                        const target = original.get(item.variant_id) || 0;
                        original.set(item.variant_id, 0);
                        if (target !== item.quantity) updates[item.key] = target;
                    });
                    const restored = await dispatchCartRequests({ requests: [{ method: 'update', payload: { updates } }], cart: currentCart, context: 'gift:edit', validate_response: true });
                    if (!restored) throw new Error('Gift restoration failed');
                }
            } catch {
                error.message = 'Unable to confirm the gift update. Please reopen your cart before continuing.';
            }
        }
        errorLabel.textContent = error.message;
        errorLabel.hidden = false;
    } finally {
        isGiftEditPending = false;
        editor.querySelectorAll('button').forEach(button => { button.disabled = false; });
        updateGiftVariantOptions(root, Number(root.dataset.stateQualifyingQuantity));
    }
}

/*
Subscription gift (A/B). Only additions are ever plan-ified: an existing gift line —
including one the shopper toggled back to one-time — is matched by variant and left
alone, so the reconciler can never fight the shopper's toggle choice. Guards:
- the stamped mode only applies while the cart's offer is still the offer that
  stamped it (_gift_sub_offer), so popup/URL/market offer swaps can't plan-ify a
  different offer's gifts under a discount never configured for subscriptions;
- only plans allocated to the gift variant are candidates (an unallocated
  selling_plan 422s the whole batched add);
- the target interval rides the _gift_sub_interval attribute, stamped from the same
  theme setting the cart drawer's picker reads (same fallback of 4), so the engine's
  pick and the drawer's off-then-on retoggle pick share one source of truth.
*/
function parseGiftSubscriptionPlanId(config, gift, attributes, selectedVariantId = gift.variant_ids?.[0]) {
    const cartAttributes = attributes || window.cartAttributes || {};
    const mode = cartAttributes._gift_sub_mode;
    if (mode !== 'toggle' && mode !== 'locked') return null;

    const stampedOffer = util.normalize.text(cartAttributes._gift_sub_offer || '');
    const activeOffer = util.normalize.text(cartAttributes._offer_handle || '');
    if (!stampedOffer || stampedOffer !== activeOffer) return null;

    const scopeIds = (cartAttributes._gift_sub_products || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
    if (!scopeIds.length) return null;

    const variantId = util.normalize.number(selectedVariantId);
    if (!variantId) return null;

    const product = (config.gift_item_products || []).find((candidate) =>
        scopeIds.includes(String(candidate.id))
        && Array.isArray(candidate.variants)
        && candidate.variants.some((variant) => util.normalize.number(variant.id) === variantId));
    if (!product || !Array.isArray(product.selling_plan_groups)) return null;

    const variant = product.variants.find((candidate) => util.normalize.number(candidate.id) === variantId);
    const allocatedPlanIds = (variant?.selling_plan_allocations || []).map((allocation) => allocation.selling_plan_id);
    if (!allocatedPlanIds.length) return null;

    const targetInterval = parseInt(cartAttributes._gift_sub_interval, 10) || 4;

    let selected = null;
    product.selling_plan_groups.forEach((group) => {
        (group.selling_plans || []).forEach((plan) => {
            if (!allocatedPlanIds.includes(plan.id)) return;
            const frequencyOption = (plan.options || []).find((option) => option.name === 'Order Frequency and Unit');
            const interval = parseInt(frequencyOption?.value, 10) || 0;
            if (interval > 0) {
                const distance = Math.abs(interval - targetInterval);
                if (!selected
                    || distance < selected.distance
                    || (distance === selected.distance && interval < selected.interval)) {
                    selected = { id: plan.id, interval, distance };
                }
            } else if (!selected) {
                selected = { id: plan.id, interval: 0, distance: Infinity };
            }
        });
    });

    return selected ? selected.id : null;
}

function applyNonGiftItemFilter(items) {
    if (!items || !Array.isArray(items)) return [];
    return items.filter((item) => !parseIsGift(item));
}

function applyGiftItemFilter(items) {
    if (!items || !Array.isArray(items)) return [];
    return items.filter((item) => parseIsGift(item));
}

function validateExistingGiftItem(item, giftItem, qualifyingQuantity) {
    const currentQuantity = item.quantity; 
    const targetQuantity = parseGiftItemQuantity(qualifyingQuantity, giftItem);
    if (currentQuantity === targetQuantity) return { valid: true, updates: null};

    return {
        valid: false,
        updates: {
            key: item.key,
            quantity: targetQuantity,
            properties: item.properties,
        }
    }  
}

/**
 * Return the capped gift quantity after unlock eligibility has been checked.
 * Shared by cart gift mutations and opt-in offer-page quantity badges.
 * Blank repeat rules reuse the initial threshold/quantity; non-stackable gifts grant once.
 * @param {number} qualifyingQuantity
 * @param {{allow_multiple?: boolean, qualifier_threshold: number, additional_qualifier_threshold?: number, quantity?: number, additional_quantity?: number, max_allowed?: number}} giftItem
 * @returns {number}
 */
function parseGiftItemQuantity(qualifyingQuantity, giftItem) {
    const { allow_multiple = false, qualifier_threshold, additional_qualifier_threshold,
        quantity, additional_quantity, max_allowed } = giftItem;
    const initialQuantity = Math.max(1, Number(quantity) || 1);
    if (!allow_multiple) return initialQuantity;
    const threshold = Math.max(1, Number(qualifier_threshold) || 1);
    const additionalThreshold = Math.max(1, Number(additional_qualifier_threshold) || threshold);
    const additionalQuantity = Math.max(1, Number(additional_quantity) || initialQuantity);
    // The initial allocation consumes the first threshold before repeat intervals start.
    const rawTargetQuantity = initialQuantity
        + Math.floor((qualifyingQuantity - threshold) / additionalThreshold) * additionalQuantity;
    return max_allowed ? Math.min(rawTargetQuantity, max_allowed) : rawTargetQuantity;
}

/*
A shipping-type apply-only code must leave the cart while a subscription line is
present: the automatic subscription free-shipping discount already covers shipping
then, and Shopify rejects a second shipping discount at checkout with a customer-
visible error banner. Handles both real cart items (selling_plan_allocation) and
projected items (selling_plan carried by the mutation recompile).
*/
function checkCartHasSubscriptionLine(items = []) {
    return items.some((item) => {
        if (!item) return false;
        // A projected mutation overwrites selling_plan explicitly ('' removes the
        // plan) while the spread keeps the stale selling_plan_allocation — the
        // explicit value must win or a toggle-off projection reads as subscribed.
        if (item.selling_plan !== undefined && item.selling_plan !== null) return !!item.selling_plan;
        // selling_plan_id: the Liquid cart-items drop's serialization of a plan.
        return !!(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan_id);
    });
}

function parseApplicableApplyOnlyTitles(config, cartItems) {
    const applyOnly = config.apply_only_discounts || [];
    if (!applyOnly.length) return [];
    const hasSubscriptionLine = checkCartHasSubscriptionLine(cartItems);
    return applyOnly
        .filter((entry) => !(entry.type === 'Free shipping' && hasSubscriptionLine))
        .map((entry) => entry.title);
}

function parseDiscountsState(config, cart) {
    const discounts = config.discounts || [];
    const cartItems = cart.items || [];
    const currentDiscounts = cart?.discount_codes;
    // Codes to apply = pricing discounts plus apply-only passengers (free shipping
    // etc.) — both must be in the applied set AND the drift comparison, or the
    // engine would strip/reapply the passenger on every mutation.
    const applyTitles = Array.from(new Set([
        ...discounts.map(discount => discount.title),
        ...parseApplicableApplyOnlyTitles(config, cartItems),
    ].filter(Boolean)));
    const out = {
        requires_update: parseDiscountUpdateRequired(applyTitles, currentDiscounts),
        active_discounts: config.active_discounts?.length ? config.active_discounts : parseActiveDiscounts(discounts, cartItems),
        discount_string: applyTitles.join(',').toLowerCase() || null,
    }
    return out;
}

function parseApplicableQuantityInCart(items, variantIds) {
    return items.filter(item => (variantIds.includes(item.variant_id) || variantIds.includes(util.normalize.number(item.id))))
        .reduce((acc, item) => acc + (Number(item.quantity) || 0), 0);
}

function parseBestApplicableDiscount(discounts, quantity) {
    let bestDiscount = null;
    let maxEligibility = -Infinity;
    if (Array.isArray(discounts)) {
        discounts.forEach((discount) => {
            const minQty = Number(discount.eligibility_minimum_quantity) || 0;
            if (minQty <= quantity && minQty > maxEligibility) {
                maxEligibility = minQty;
                bestDiscount = discount;
            }
        });
    }
    return bestDiscount;
}

function parseActiveDiscounts(discounts, items) {
    const activeDiscounts = [];
    // Parse the "best" discount for each set
    const discountSets = buildDiscountSets(discounts);
    discountSets.forEach((set) => {
        const setApplicableQuantity = parseApplicableQuantityInCart(applyNonGiftItemFilter(items), set.baseVariantIds);
        const bestDiscount = parseBestApplicableDiscount(set.discounts, setApplicableQuantity);
        if (bestDiscount) activeDiscounts.push(bestDiscount);
    });
    // MAY NEED TO HANDLE SETS THAT APPLY TO MULTIPLE VARIANTS, BUT THINK WE'RE OKAY FOR NOW WITHOUT
    return activeDiscounts;
}

function buildDiscountSets(discounts) {
    if (!Array.isArray(discounts)) return [];

    const setsMap = new Map();
    for (const discount of discounts) {
        const variantIds = Array.isArray(discount.variant_ids)
            ? [...discount.variant_ids].sort()
            : [];

        if (!variantIds.length) continue;

        const key = `${discount.method}::${variantIds.join(',')}::${Number(discount.variantCount) || variantIds.length}`;

        if (!setsMap.has(key)) {
            setsMap.set(key, {
                key,
                method: discount.method,
                baseVariantIds: variantIds,
                baseCount: Number(discount.variantCount) || variantIds.length,
                discounts: [],
            });
        }
        setsMap.get(key).discounts.push(discount);
    }
    return [...setsMap.values()];
}

function parseDiscountUpdateRequired(configTitles, cartDiscounts) {
    const cartCodes = cartDiscounts ? Array.from(new Set(cartDiscounts.map(discount => discount.code.toLowerCase().trim()).sort())) : [];
    const configCodes = configTitles ? Array.from(new Set(configTitles.map(title => title.toLowerCase().trim()).sort())) : [];
    const equal = util.compare.array.unorderedEqual(cartCodes, configCodes);

    return !equal;
}

function parseActivePreorderRules(rules = [], discounts = []) {
    if (!rules.length || !discounts.length ) return [];
    return parseValidPreorderRules(rules)
        .filter(rule => discounts.some(discount => discount.preorder_rules.includes(rule.id)));
}

function parsePreorderDelay(value) {
    const delay = Number(value);
    return Number.isFinite(delay) && delay >= MIN_PREORDER_DELAY_DAYS ? delay : null;
}

function parseValidPreorderRules(rules = []) {
    return rules.filter(rule => (
        rule?.id && parsePreorderDelay(rule.delay_days) !== null
    ));
}

function parsePreorderRuleState(rules = []) {
    const validRules = parseValidPreorderRules(rules);
    if (!validRules.length) return null;

    return {
        delay: validRules.reduce((max, rule) => (
            Math.max(max, parsePreorderDelay(rule.delay_days))
        ), MIN_PREORDER_DELAY_DAYS),
        ruleIds: validRules.map(rule => rule.id).filter(Boolean),
    };
}

function parseApplicablePreorderRules(rules = [], discounts = [], items = []) {
    const activeRules = parseActivePreorderRules(rules, discounts);
    if (!activeRules.length || !items.length) return [];

    const cartVariantIds = new Set(
        applyNonGiftItemFilter(items)
            .map(item => util.normalize.number(item.variant_id || item.id))
            .filter(Boolean)
    );

    return activeRules.filter(rule => (
        Array.isArray(rule.variants)
        && rule.variants.some(variantId => cartVariantIds.has(util.normalize.number(variantId)))
    ));
}

function parsePreorderState(config, cart, activeDiscounts) {
    const rules = config.preorder_rules || [];
    const cartAttributes = cart.attributes || {};
    const cartPreorderKeys = Array.from(Object.keys(cartAttributes).filter(key => key.includes('preorder')));
    const items = cart.items || [];
    const cartPreorderEligible = cartAttributes._preorder_eligible === "true" ? true : false;
    const candidatePreorderState = parsePreorderRuleState(rules);
    const nextPreorderEligible = candidatePreorderState !== null;

    const cartPreorderActive = cartAttributes._preorder === "true" ? true : false;
    const preorderAttributeRequested = config.attributes?._preorder;
    const requestedPreorderActive = preorderAttributeRequested === undefined
        ? cartPreorderActive
        : preorderAttributeRequested === "true";
    const applicablePreorderRules = parseApplicablePreorderRules(rules, activeDiscounts, items);
    const activePreorderState = parsePreorderRuleState(applicablePreorderRules);
    const isPreorderActivation = !cartPreorderActive && requestedPreorderActive;
    const nextPreorderActive = requestedPreorderActive
        && (!isPreorderActivation || activePreorderState !== null);
    const nextPreorderState = nextPreorderActive && activePreorderState
        ? activePreorderState
        : candidatePreorderState;
    const nextPreorderDelay = nextPreorderState?.delay ?? null;
    const nextPreorderRuleIds = nextPreorderActive && activePreorderState
        ? activePreorderState.ruleIds.join(',')
        : '';

    const updateRequired = (
        cartPreorderEligible !== nextPreorderEligible
        || cartPreorderActive !== nextPreorderActive
        || (
            nextPreorderDelay !== null
            && cartAttributes._preorder_ship_delay !== nextPreorderDelay.toString()
        )
        || (cartAttributes._preorder_rules_ids || '') !== nextPreorderRuleIds
        || (cartPreorderKeys.length > 0 && !nextPreorderEligible)
    );

    const out = { requires_update: updateRequired }

    // CART ATTRIBUTE COVERAGE
    if (updateRequired) {
        out.attributes = {}
        if (nextPreorderEligible) {
            if (!cartPreorderEligible) out.attributes._preorder_eligible = 'true';
            if (cartPreorderActive !== nextPreorderActive) out.attributes._preorder = nextPreorderActive ? 'true' : '';
            if (
                nextPreorderDelay !== null
                && cartAttributes._preorder_ship_delay !== nextPreorderDelay.toString()
            ) {
                out.attributes._preorder_ship_delay = nextPreorderDelay.toString();
            }
            if ((cartAttributes._preorder_rules_ids || '') !== nextPreorderRuleIds) {
                out.attributes._preorder_rules_ids = nextPreorderRuleIds;
            }
        } else {
            PREORDER_CART_ATTRS.forEach(attr => {
                if (cartAttributes[attr]) out.attributes[attr] = '';
            });
        }
    }

    // LINE ITEM COVERAGE
    const lineChanges = parsePreorderChanges(items, activeDiscounts, rules, nextPreorderEligible, nextPreorderActive);
    if (lineChanges.length > 0) {
        out.requires_update = true;
        out.line_changes = lineChanges;
    }
    return out;
}

function parsePreorderChanges(items, activeDiscounts, rules, nextEligible, nextActive) {
    const out = [];
    const activeRules = parseActivePreorderRules(rules, activeDiscounts);
    const preorderActive = nextActive && nextEligible ? true : false;
    const activePreorderItems = items.filter(item => item.properties?._isPreorder === "true");
    const preorderEligibleVariants = Array.from(new Set(activeRules.flatMap(rule => rule.variants)) || []);
    const eligibleInCart = items.filter(item => preorderEligibleVariants.includes(item.variant_id) && !parseIsGift(item));
    if (!eligibleInCart.length && !activePreorderItems.length) return out;

    if (!preorderActive || !nextEligible) {
        activePreorderItems.forEach((item) => {
            out.push(clearPreorderLineProps(item));
        });
        return out;
    }

    // IF WE GET HERE, WE'RE ENABLING PREORDER
    eligibleInCart.forEach((item) => {
        const applicableRules = activeRules.filter(rule => rule.variants.includes(item.variant_id));
        if (!applicableRules.length) return out.push(clearPreorderLineProps(item));

        const nextItem = applyPreorderLineUpdates(item, applicableRules, activeDiscounts);
        if (nextItem) out.push(nextItem);
    });

    return out;
}

function clearPreorderLineProps(item) {
    const nextItem = {
        id: item.key,
        variant_id: item.variant_id, // This doesnt go into the final payload, but we need it if we decide to run a clear / add instead of unique change requests.
        quantity: item.quantity, // This doesnt go into the final payload, but we need it if we decide to run a clear / add instead of unique change requests.
        change_types: ['properties'], // This doesnt go into the final payload, but we need it if we decide to run a clear / add instead of unique change requests.
        properties: {}
    }
    // When running a change on properties, we need to deliver a wholesale update of the properties object.
    Object.entries(item.properties).forEach(([prop, value]) => {
        if (!PREORDER_LINE_PROPS.includes(prop)) {
            nextItem.properties[prop] = value;
        }
    });
    return nextItem;
}

function parseOriginalFromDiscount(discountPrice, discountMethod, discountAmount) {
    if (!discountPrice) return null;
    if (!discountMethod) return null;
    if (!discountAmount) return null;

    return discountMethod === 'Percentage'
        ? Math.floor(discountPrice / ((100 - discountAmount) / 100))
        : discountPrice + (discountAmount * 100);
}

function applyPreorderLineUpdates(item, rules, discounts) {
    const bestRule = rules.reduce((best, rule) => {
        if (
            !best || 
            (rule.price_preorder && best.price_preorder && rule.price_preorder.amount < best.price_preorder.amount)
        ) {
            return rule;
        }
        return best;
    }, null);

    const ruleDiscounts = discounts.filter(discount => discount.preorder_rules.includes(bestRule.id));
    if (!ruleDiscounts.length) throw new Error('[OfferEngine] Preorder rule discount not found');
    const ruleDiscount = ruleDiscounts.reduce((best, discount) => {
        if (!best) return discount;
        return discount.amount > best.amount ? discount : best;
    }, null);

    const nextPreorderOriginalPrice = parseOriginalFromDiscount(bestRule.price_preorder.amount, ruleDiscount.method, ruleDiscount.amount);

    const itemPreorderOriginalPrice = item.properties._preorder_price ? util.normalize.number(item.properties._preorder_price) * 100 : null;
    // If everything is the same, don't update anything
    if (nextPreorderOriginalPrice === itemPreorderOriginalPrice && item.price === bestRule.price_preorder.amount) return null;
    const itemMsrp = item.properties._preorder_original_msrp 
        ? util.normalize.number(item.properties._preorder_original_msrp) * 100 
        : item.price && (!item.properties?._preorder_price || item.properties._preorder_price !== item.price) 
            ? item.price 
            : null;
    // if (!itemMsrp) throw new Error('[OfferEngine] Item MSRP not found');
    // Otherwise, we need to update preorder props
    const nextItem = {
        id: item.key,
        variant_id: item.variant_id, // This doesnt go into the final payload, but we need it if we decide to run a clear / add instead of unique change requests.
        quantity: item.quantity, // This doesnt go into the final payload, but we need it if we decide to run a clear / add instead of unique change requests.
        properties: {
            ...item.properties,
            _isPreorder: 'true',
            ...(itemMsrp != null ? { _preorder_original_msrp: itemMsrp / 100 } : {}),
            _preorder_price: parseFloat((nextPreorderOriginalPrice / 100).toFixed(2)),
            _preorder_discount_rate: parseActiveDiscountRate(bestRule.price_preorder.amount, itemMsrp),
            _preorder_market_currency: window.localeDetails?.currency?.iso_code || 'USD',
        },
    }
    return nextItem;  
}

function parsePriceOverrideState(config, cart, activeDiscounts) {
    const lineChanges = parsePriceOverrideChanges(cart.items || [], activeDiscounts, config);

    return {
        requires_update: lineChanges.length > 0,
        line_changes: lineChanges,
    };
}

function parsePriceOverrideChanges(items = [], activeDiscounts = [], config = {}) {
    const out = [];
    const considered = items.filter(item => item.key && !parseIsGift(item));

    considered.forEach(item => {
        const nextItem = parseNextRequestItemState(
            util.normalize.number(item.variant_id || item.id),
            activeDiscounts,
            config
        );
        const currentProperties = item.properties || {};
        const nextProperties = { ...currentProperties };

        if (nextItem?.price_override && nextItem?.applicable_discount) {
            const requiredProps = parseAddRequestProps(nextItem, {
                local_original_price: parseLineOriginalPrice(item),
            });

            if (requiredProps._transformed_at_once != null) {
                nextProperties._transformed_at_once = requiredProps._transformed_at_once;
            } else {
                delete nextProperties._transformed_at_once;
            }
        } else {
            delete nextProperties._transformed_at_once;
        }

        const transformedAtOnceMatches = currentProperties._transformed_at_once
            == nextProperties._transformed_at_once;
        const propertiesMatch = transformedAtOnceMatches
            && util.compare.object.equal(currentProperties, nextProperties, { loose: true });
        if (propertiesMatch) return;

        out.push({
            type: 'change',
            body: {
                key: item.key,
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: nextProperties,
            },
        });
    });

    return out;
}

function handleShadowValidation(sections) {
    const invalid = { valid: false, config: null, offer_exists: false };
    if (!sections) {
        console.warn('[OfferEngine] Shadow validation skipped: missing sections payload');
        return invalid;
    }

    const html = sections['offer-engine-json']
    if (!html) return invalid;

    const root = queryShadowEl(html, SELECTORS.root);
    if (!root) return invalid;

    const shadowConfig = hydrateConfigParams(root, true);
    const offerValid = (shadowConfig && shadowConfig.offer && shadowConfig.offer.title) ? true : false;

    return {
        valid: true,
        config: shadowConfig,
        offer_exists: offerValid,
    }
}

function queryShadowEl(html, selector) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.querySelector(selector);
}

document.addEventListener(ThemeEvents.cartUpdate, handleCartResponse);

function parseIsGift(item) {
    const value = item?.properties?._is_gift;
    return value === true || value === 'true';
}

// CURRENTLY UNUSED BUT LEAVING FOR NOW
function filterSectionIdInputs(values) {
    if (!Array.isArray(values)) return [];
    return values.filter((value) => value in CART_UPDATE_SECTION_IDS);
}

function resolveSectionInputs(inputs = []) {
    if (!Array.isArray(inputs)) return [];

    const out = [];
    inputs.forEach((input) => {
        const resolver = CART_UPDATE_SECTION_IDS[input];
        if (!resolver) return;

        const resolved = typeof resolver === 'function' ? resolver() : resolver;
        if (Array.isArray(resolved)) {
            out.push(...resolved);
        } else if (resolved) {
            out.push(resolved);
        }
    });

    return out;
}

function createCartRequestSectionPlan(context = "validate") {
    const sectionIds = context === 'offer:set'
        ? resolveSectionInputs(['offer_config'])
        : resolvePrioritizedSectionIds(
            resolveSectionInputs(normalizeSectionIds(Object.keys(CART_UPDATE_SECTION_IDS)))
        );

    return {
        all: sectionIds,
        bundled: sectionIds.slice(0, MAX_BUNDLED_SECTION_COUNT),
        deferred: sectionIds.slice(MAX_BUNDLED_SECTION_COUNT),
    };
}

function resolveOfferSetFollowupSectionIds(sections = null) {
    const renderedSectionIds = sections ? Object.keys(sections) : [];
    return resolvePrioritizedSectionIds(
        resolveSectionInputs(normalizeSectionIds(Object.keys(CART_UPDATE_SECTION_IDS)))
    ).filter((sectionId) => !renderedSectionIds.includes(sectionId));
}

function resolvePrioritizedSectionIds(ids = []) {
    const cartSectionIds = readCartComponentSectionIds();
    return normalizeSectionIds(ids).sort((a, b) => (
        compareSectionPriority(a, b, cartSectionIds)
    ));
}

function compareSectionPriority(a, b, cartSectionIds = []) {
    const aWeight = parseSectionGlobalPriority(a, cartSectionIds);
    const bWeight = parseSectionGlobalPriority(b, cartSectionIds);
    if (aWeight !== bWeight) return aWeight - bWeight;

    const aScore = parseSectionViewportScore(a);
    const bScore = parseSectionViewportScore(b);
    if (aScore !== bScore) return aScore - bScore;

    return compareSectionDomOrder(a, b);
}

function parseSectionGlobalPriority(sectionId, cartSectionIds = []) {
    if (sectionId === 'offer-engine-json') return 0;
    if (sectionId.includes('header_section')) return 1;
    if (sectionId.includes('announcement')) return 2;
    if (cartSectionIds.includes(sectionId)) return 3;
    return 10;
}

function parseSectionViewportScore(sectionId) {
    const section = getSectionElement(sectionId);
    if (!section) return Number.MAX_SAFE_INTEGER;

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const viewportCenter = viewportHeight / 2;

    if (rect.top < viewportHeight && rect.bottom > 0) {
        const sectionCenter = rect.top + (rect.height / 2);
        return Math.abs(sectionCenter - viewportCenter);
    }

    if (rect.bottom <= 0) return Math.abs(rect.bottom) + viewportHeight;
    return Math.abs(rect.top - viewportHeight) + viewportHeight;
}

function compareSectionDomOrder(a, b) {
    const aSection = getSectionElement(a);
    const bSection = getSectionElement(b);
    if (!aSection || !bSection || aSection === bSection) return 0;

    return aSection.compareDocumentPosition(bSection) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}

function getSectionElement(sectionId) {
    if (!sectionId) return null;
    return document.getElementById(`shopify-section-${sectionId}`);
}

function attachSectionsToRequest(request, sectionIds = []) {
    if (!request) return;
    const sections = normalizeSectionIds(sectionIds);
    if (!sections.length) return;

    if (!request.payload) request.payload = {};
    request.payload.sections = sections;
    request.payload.sections_url = getCurrentSectionsUrl();
}

async function fetchCartSections(sectionIds = []) {
    const sections = normalizeSectionIds(sectionIds).slice(0, MAX_BUNDLED_SECTION_COUNT);
    if (!sections.length) return null;

    const searchParams = new URLSearchParams({
        sections: sections.join(','),
        sections_url: getCurrentSectionsUrl(),
    });
    const response = await cartFetch(`/cart?${searchParams.toString()}`);
    return response?.sections || null;
}

async function fetchDeferredCartSections(sectionIds = []) {
    const ids = normalizeSectionIds(sectionIds);
    if (!ids.length) return;

    for (let i = 0; i < ids.length; i += MAX_BUNDLED_SECTION_COUNT) {
        const chunk = ids.slice(i, i + MAX_BUNDLED_SECTION_COUNT);
        const sections = await fetchCartSections(chunk);
        handleCartDomUpdates(sections, null, chunk);
    }
}

function startSectionRefreshUi(sectionIds = []) {
    normalizeSectionIds(sectionIds).forEach((sectionId) => {
        const section = getSectionElement(sectionId);
        if (!section) return;
        section.setAttribute(OFFER_REFRESH_STATE_ATTR, OFFER_REFRESH_LOADING_STATE);
    });
}

function endSectionRefreshUi(sectionIds = []) {
    normalizeSectionIds(sectionIds).forEach((sectionId) => {
        const section = getSectionElement(sectionId);
        if (!section) return;
        section.removeAttribute(OFFER_REFRESH_STATE_ATTR);
    });
}

function readPriceSectionIds() {
    const ids = new Set();
    const wrappers = document.querySelectorAll(SELECTORS.priceWrapper);
    for (const node of wrappers) {
        const section = node.closest('.shopify-section');
        if (!section?.id) continue;
        ids.add(section.id.replace('shopify-section-', ''));
    }
    return Array.from(ids);
}

function readCartComponentSectionIds() {
    const ids = new Set();
    const cartComponents = document.querySelectorAll('cart-items-component[data-section-id]');

    for (const component of cartComponents) {
        if (!(component instanceof HTMLElement)) continue;
        const sectionId = component.dataset.sectionId || null;
        if (sectionId) ids.add(sectionId);
    }

    return Array.from(ids);
}

function normalizeSectionIds(ids) {
    if (!Array.isArray(ids)) return [];
    const set = new Set();
    for (const id of ids) {
        const normalized = util?.normalize?.text ? util.normalize.text(id) : String(id || '').trim();
        if (normalized) set.add(normalized);
    }
    return Array.from(set);
}

async function handleCartResponse(response = {}, skipCheck = false) {
    let cart = response?.confirmed_cart 
        ? response.confirmed_cart 
        : response?.detail?.resource?.token 
            ? response.detail.resource 
            : response?.detail?.data?.cart?.token ? response.detail.data.cart : response;
    // When we're handling an "add" event, we'll need to fetch the cart in the background so we maintain our data layer.
    if (!cart || !cart.token) cart = await cartFetch('get', {});

    if (!cart) {
        console.error('[OfferEngine] Unable to parse cart response');
        return
    }    
    
    if (response?.type === ThemeEvents.cartUpdate) {
        const sectionId = CART_UPDATE_SECTION_IDS.offer_config;
        const section = response.detail?.data?.sections?.[sectionId];
        if (section) handleCartDomUpdates({ [sectionId]: section }, null);
    }

    window.lastCart = cart;
    window.cartAttributes = cart.attributes || {};
    updateKlaviyoOfferBlocker(window.cartAttributes);
    window.config.params.cart_attributes = window.cartAttributes;
    if (Array.isArray(cart.discount_codes)) window.cartDiscountCodes = cart.discount_codes || [];
    if (Array.isArray(cart.items)) { 
        window.cartItems = cart.items || [];
        window.config.params.cart_items = cart.items || [];
    }
    if (window.config.params.cart_items) window.cartItems = window.config.params.cart_items;

    if (!skipCheck && parseRehydrationRequired(cart)) {
        configParams = hydrateConfigParams();
    } else {
        configParams = window.config.params;
    }

    configState = hydrateConfigState(configParams, cart);
    updateMainPreorderState(configState.active_preorder === true);
    document.dispatchEvent(new CustomEvent(OFFER_CART_RESOLVED_EVENT, { detail: { cart } }));

}

/* Affects:
- Cart properties (always)
- Line items (when applicable)
*/
async function handleCartPreorderToggle(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const checked = target.checked;
    if (window.cartAttributes._preorder !== checked.toString()) {
        const nextConfig = {
            ...window.config.params,
            attributes: {
                ...window.config.params.attributes,
                _preorder: checked ? 'true' : '',
            },
        }
        const states = parseCartReconciliationState(nextConfig, parseCurrentCart())
        if (states.requests.length > 0) {
            await dispatchCartRequests({requests: states.requests, cart_loading: true});
        } else {
            target.checked = window.cartAttributes._preorder === 'true';
        }
    }
}

function parseRehydrationRequired(cart) {
    if (!window.config?.params) return true;
    const cartAttributes = cart.attributes || {};

    const cartHas = {
        _offer_handle: false,
    }
    for (const [key, value] of Object.entries(cartAttributes)) {
        switch (key) {
            case '_offer_handle':
                cartHas._offer_handle = true;
                if (util.normalize.lower(window.config?.params?.offer?.title || '') !== util.normalize.lower(value)) {
                    return true;
                }
                break;
            default:
                break;
        }
    }

    if (!cartHas._offer_handle && util.normalize.lower(window.config?.params?.offer?.title) !== util.normalize.lower(cartAttributes._offer_handle)) return true;
    return false;
}

async function cartFetch(endpoint, payload, raw = false, options = {}) {
    const url = CART_ROUTES[endpoint] ? CART_ROUTES[endpoint] : endpoint; // Allow for custom endpoints to be passed if needed.
    const method = endpoint === 'get' ? 'GET' : 'POST';
    // Only preparation reads opt in; never time out an in-flight cart mutation.
    const controller = method === 'GET' && options.timeoutMs > 0 ? new AbortController() : null;
    const timeout = controller
        ? window.setTimeout(() => controller.abort(), options.timeoutMs)
        : null;
    try {
        const res = await fetch(url, {
            method,
            headers: {
                ...(method !== 'GET' && { 'Content-Type': 'application/json' }),
                'Accept': 'application/json',
            },
            ...(controller ? { signal: controller.signal } : {}),
            ...(method !== 'GET' ? { body: JSON.stringify(payload) } : {}),
        });

        return raw ? res : await res.json();
    } catch (error) {
        console.error('[OfferEngine.cartFetch] Cart Fetch Error', error);
    } finally {
        if (timeout !== null) window.clearTimeout(timeout);
    }
}

function buildParsedAddRequest(id, quantity = 1, attributes = {}, properties = {}, sellingPlan = null) {
    const item = {
        id,
        quantity,
        properties,
        ...(sellingPlan ? { selling_plan: sellingPlan } : {}),
    };

    return {
        type: 'add',
        body: {
            attributes,
            items: [item]
        }
    }
}

function extractParamMatches(source = [], sourceKey = null, sourceSubkey = null, target = null, value = null) {
    if (!sourceKey || !sourceSubkey || !target || !value) return [];

    const out = [];
    source.forEach(item => {
        if (Array.isArray(item[sourceKey]) && item[sourceKey].length > 0) {
            item[sourceKey].forEach(sourceVal => {
                if (out.find(opt => opt[sourceSubkey] === sourceVal)) return;
                const match = target.find(opt => opt[sourceSubkey] === sourceVal) || null;
                if (match) out.push(match);
            });
        }
    });

    return out;
}

function extractLowestApplicableMatch(source = [], matchKey = null, matchValue = null, compareKey = null, compareSubkey = null, operator = '<') {
    if (!Array.isArray(source) || !matchKey || !matchValue || !compareKey) return null;

    return source
        .filter(item => item?.[matchKey]?.includes(matchValue))
        .reduce((best, item) => {
            if (!best) return item;

            const itemValue = compareSubkey ? item?.[compareKey]?.[compareSubkey] : item?.[compareKey];
            const bestValue = compareSubkey ? best?.[compareKey]?.[compareSubkey] : best?.[compareKey];

            if (operator === '<') return itemValue < bestValue ? item : best;
            return itemValue < bestValue ? item : best;
    }, null);
}

function parseNextRequestItemState(id, applicable_discounts = [], config = window.config?.params || {}) {
    if (!id) return null;

    const applicable_discount = extractLowestApplicableMatch(applicable_discounts, 'variant_ids', id, 'amount', 'amount', '>');

    const preorder_rules = extractParamMatches(
        applicable_discounts,
        'preorder_rules',
        'id',
        parseValidPreorderRules(config?.preorder_rules),
        'id'
    );
    const preorder_rule = extractLowestApplicableMatch(preorder_rules, 'variants', id, 'price_preorder', 'amount', '<');

    const price_overrides = extractParamMatches(applicable_discounts, 'variant_price_overrides', 'id', config?.variant_price_overrides, 'id');
    const price_override = extractLowestApplicableMatch(price_overrides, 'variants', id, 'price', 'amount', '<');

    return {
        applicable_discount,
        preorder_rule,
        price_override,
    };
}

async function handleAddPayloadData(submitter, formData) {
    const preparation = handleFirstInteraction();
    const pendingAdd = { reconciliation: null };
    // An add arriving after reconciliation dispatch starts keeps the sequential path.
    if (firstInteractionAcceptsAdd && formData?.get('id')) {
        if (firstInteractionAdd) {
            firstInteractionAcceptsAdd = false;
            firstInteractionAdd = null;
        } else {
            firstInteractionAdd = pendingAdd;
        }
    }
    await preparation;
    return parseAddPayloadData(submitter, formData, pendingAdd);
}

function parseAddPayloadData(submitter, formData, options = {}) {
    const context = createCartMutationContext({ useLastCart: false });
    const reconciliation = options.reconciliation;
    const cartAttributes = reconciliation
        ? { ...context.cart.attributes, ...reconciliation.attributes }
        : context.cart.attributes;
    // Keep server line keys; gift mutations are recalculated for the final add quantity.
    if (reconciliation) {
        context.cartItems = recompileNextCart(context.cartItems, reconciliation.changes);
    }
    const out = {
        attributes: reconciliation ? { ...reconciliation.attributes } : {},
        properties: {},
    };
    if (!formData) return out;

    const preorderTogglePresent = formData.get('ref[_preorder_toggle]') === 'true';
    const preorderContext = preorderTogglePresent && formData.get('ref[_preorder]') === 'true';
    const requestedPreorderActive = preorderTogglePresent ? preorderContext : undefined;
    const shouldClearPreorder = preorderTogglePresent
        && !preorderContext
        && (
            cartAttributes?._preorder === true
            || cartAttributes?._preorder === 'true'
        );

    const { id, quantity, local_original_price, selling_plan } = extractFormDataValues(formData, ['id', 'quantity', 'local_original_price', 'selling_plan', 'sections', 'sectionsUrl'], { id: 'number', quantity: 'number', local_original_price: 'number', selling_plan: 'number' }, { quantity: 1 });
    if (!id) return out;

    const attrEntries = Array.from(formData.entries()).filter(option => option[0].startsWith('attrs['));
    attrEntries.forEach((entry) => {
        const [key, value] = entry;
        const extractedKey = key.replace(/^attrs\[|\]$/g, '');
        if (preorderContext && PREORDER_CART_ATTRS.includes(extractedKey)) {
            out.attributes[extractedKey] = value;
        }
    });
    if (shouldClearPreorder) out.attributes._preorder = null;

    const addMods = [{
        type: 'add',
        body: {
            items: [{
                id,
                quantity,
                properties: {},
                ...(selling_plan ? { selling_plan } : {}),
            }]
        }
    }];
    const projectedAdd = projectCartMutationState(context.cartItems, addMods, {
        preorderActive: requestedPreorderActive,
    });
    const applicablePreorderRules = parseApplicablePreorderRules(
        window.config?.params?.preorder_rules,
        projectedAdd.nextState.broad.applicable_discounts,
        projectedAdd.nextItems
    );
    const projectedPreorderState = parsePreorderRuleState(applicablePreorderRules);
    const preorderActive = requestedPreorderActive === true
        ? projectedPreorderState !== null
        : requestedPreorderActive;

    if (requestedPreorderActive === true) {
        if (projectedPreorderState) {
            out.attributes._preorder = 'true';
            out.attributes._preorder_eligible = 'true';
            out.attributes._preorder_ship_delay = projectedPreorderState.delay.toString();
            out.attributes._preorder_rules_ids = projectedPreorderState.ruleIds.join(',');
        } else {
            out.attributes._preorder = null;
            out.attributes._preorder_rules_ids = null;
        }
    }

    const nextRequestItem = parseNextRequestItemState(
        id,
        projectedAdd.nextState.broad.applicable_discounts
    );

    out.properties = parseAddRequestProps(nextRequestItem, {
        preorderContext: preorderActive === undefined
            ? cartAttributes?._preorder === true || cartAttributes?._preorder === 'true'
            : preorderActive,
        local_original_price,
    });
    
    // STEP 1: Hydration and normalization of the "original" request
    const hydratedBaseRequest = buildParsedAddRequest(id, quantity, out.attributes, out.properties, selling_plan);
    // STEP 2: Transformation of the original request to compare incoming items against the next state and splits on newly add vs update
    const parsedBaseRequests = reparseAddRequest(hydratedBaseRequest.body.items, projectedAdd.nextItems);
    // STEP 3: Given the output of reparseAddRequest, we can now make a determination of the TYPE of request(s) we need 
    const mergedLinePayload = parsedBaseRequests.matches_exist ? mergeLinePayloads(parsedBaseRequests, 'add') : [];
    // STEP 4: Recompilation of the next state based on the work above
    const baseCartMods = [...mergedLinePayload];
    if (parsedBaseRequests.add_lines.length > 0) {
        baseCartMods.push({ type: 'add', body: { items: parsedBaseRequests.add_lines } });
    }

    const requestsByType = createCartMutationRequestBuckets({
        updates: mergedLinePayload.filter(mod => mod.type === 'update'),
        changes: mergedLinePayload.filter(mod => mod.type === 'change'),
        adds: parsedBaseRequests.add_lines,
    });
    if (reconciliation) {
        mergeManagedLineChanges(requestsByType, reconciliation.changes.filter(change => (
            !requestsByType.changes.some(update => update.body.key === change.body.key)
        )));
    }
    const plan = resolveCartMutationRequestPlan({
        context,
        requestsByType,
        simulationMods: baseCartMods,
        currentUpdates: mergedLinePayload,
        nextStateOptions: {
            preorderActive: reconciliation && preorderActive === undefined
                ? cartAttributes?._preorder === 'true' || window.config.params.attributes?._preorder === 'true'
                : preorderActive,
        },
        attributes: out.attributes,
        reconcileDiscounts: Boolean(reconciliation),
    });

    // When we only have one request that includes one item, that tells us that we can take the theme default route.
    // A pending shipping-code suppression must dispatch (the default route drops
    // the discount update) — only set for offers carrying shipping apply-only codes.
    const clearsReconciledAttribute = reconciliation && Object.values(out.attributes).some(value => value === null);
    if (!clearsReconciledAttribute && !shouldClearPreorder && plan.totalRequestCount <= 1 && plan.requestsByType.adds.length === 1 && plan.suppression_discount === undefined) {
        return out;
    } else {
        const completion = plan.requests.length > 0
            ? dispatchCartRequests({ requests: plan.requests, open_cart: true, validate_response: true })
            : Promise.resolve(false);
        return { no_op: true, completion };
    }

}

async function parseChangePayloadData(submitter = null, formData = null) {
    const context = createCartMutationContext();
    const payload = parseMutationPayloadInput(submitter, formData);
    const key = payload?.key || payload?.id || null;
    if (!key) return false;

    const existingLine = findCartLineByKey(key, context.cartItems);
    const quantity = payload.quantity !== undefined
        ? util.normalize.number(payload.quantity, { fallback: 0 })
        : existingLine?.quantity;
    const request = {
        key,
        variant_id: util.normalize.number(payload.variant_id)
            || util.normalize.number(existingLine?.variant_id)
            || parseVariantIdFromLineKey(key),
        ...(quantity !== undefined ? { quantity } : {}),
        ...(payload.properties !== undefined ? { properties: payload.properties || {} } : {}),
        ...(payload.selling_plan !== undefined ? { selling_plan: payload.selling_plan } : {}),
    };
    const simulation = {
        ...request,
        quantity: quantity !== undefined ? quantity : 0,
        properties: payload.properties !== undefined
            ? payload.properties || {}
            : existingLine?.properties || {},
    };

    const requestsByType = createCartMutationRequestBuckets({
        updates: [],
        changes: [{ type: 'change', body: request }],
        adds: [],
    });
    const plan = resolveCartMutationRequestPlan({
        context,
        requestsByType,
        simulationMods: [{ type: 'change', body: simulation }],
        attributes: payload.attributes || {},
        discount: payload.discount,
    });
    if (!plan.requires_intercept) return false;
    if (!plan.requests.length) return false;

    await dispatchCartRequests({ requests: plan.requests, cart: context.cart });
    return true;
}

async function parseUpdatePayloadData(submitter = null, formData = null) {
    const context = createCartMutationContext();
    const payload = parseMutationPayloadInput(submitter, formData);
    const rawUpdates = payload?.updates;
    const updates = [];

    if (Array.isArray(rawUpdates)) {
        rawUpdates.forEach(update => {
            const normalized = normalizeCartUpdateLine(update, context.cartItems);
            if (normalized) updates.push(normalized);
        });
    } else if (rawUpdates && typeof rawUpdates === 'object') {
        Object.entries(rawUpdates).forEach(([key, quantity]) => {
            const normalized = normalizeCartUpdateLine({ key, quantity }, context.cartItems);
            if (normalized) updates.push(normalized);
        });
    } else if (payload?.key || payload?.id) {
        const normalized = normalizeCartUpdateLine(payload, context.cartItems);
        if (normalized) updates.push(normalized);
    } else if (payload && typeof payload === 'object') {
        Object.entries(payload).forEach(([key, quantity]) => {
            if (key === 'attributes' || key === 'discount' || key === 'sections' || key === 'sections_url') return;
            const normalized = normalizeCartUpdateLine({ key, quantity }, context.cartItems);
            if (normalized) updates.push(normalized);
        });
    }

    if (!updates.length) return false;

    const requestsByType = createCartMutationRequestBuckets({
        updates: updates.map(body => ({ type: 'update', body })),
        changes: [],
        adds: [],
    });
    const plan = resolveCartMutationRequestPlan({
        context,
        requestsByType,
        simulationMods: requestsByType.updates,
        attributes: payload?.attributes || {},
        discount: payload?.discount,
    });
    if (!plan.requires_intercept) return false;
    if (!plan.requests.length) return false;

    await dispatchCartRequests({ requests: plan.requests, cart: context.cart });
    return true;
}

function createCartMutationContext(options = {}) {
    const { useLastCart = true } = options;
    const cart = useLastCart ? window.lastCart || parseCurrentCart() : parseCurrentCart();
    return {
        cart,
        cartItems: Array.isArray(cart.items) ? cart.items : [],
        discounts: window.config?.params?.discounts || [],
    };
}

function createCartMutationRequestBuckets(requests = {}) {
    return {
        updates: Array.isArray(requests.updates) ? requests.updates : [],
        changes: Array.isArray(requests.changes) ? requests.changes : [],
        adds: Array.isArray(requests.adds) ? requests.adds : [],
    };
}

function resolveCartMutationRequestPlan(options = {}) {
    const {
        context = createCartMutationContext(),
        requestsByType = createCartMutationRequestBuckets(),
        simulationMods = [],
        currentUpdates = [],
        nextStateOptions = {},
        attributes = {},
        discount,
        reconcileDiscounts = false,
    } = options;
    const projected = projectCartMutationState(context.cartItems, simulationMods, nextStateOptions);
    const plan = compileCartMutationConsequences(
        requestsByType,
        projected,
        { currentUpdates }
    );
    const finalProjection = projectCartMutationState(
        context.cartItems,
        createCartMutationSimulationMods(plan.requestsByType),
        nextStateOptions
    );
    const shouldClearPreorderAttr = checkShouldClearPreorderAttr(context.cart, finalProjection.nextItems);
    const shouldHideGifts = checkShouldHideGifts(context.cart, finalProjection.nextItems);
    if (shouldHideGifts) {
        handlePendingGiftRemoval();
    }
    const nextAttributes = shouldClearPreorderAttr
        ? {
            ...attributes,
            _preorder: null,
        }
        : attributes;

    // Shipping-type apply-only suppression can flip when this mutation adds or
    // removes a subscription line; the discount set must move in the same batch
    // or checkout shows a "code couldn't be used" banner. Guarded on the offer
    // actually carrying a shipping apply-only code. First-add reconciliation also
    // validates the full discount-code set against the final projected cart.
    let suppressionDiscount;
    const applyOnlyShipping = (window.config?.params?.apply_only_discounts || [])
        .filter((entry) => entry.type === 'Free shipping');
    if (reconcileDiscounts || (applyOnlyShipping.length && discount === undefined)) {
        const projectedDiscountsState = parseDiscountsState(window.config.params, {
            items: finalProjection.nextItems,
            discount_codes: context.cart?.discount_codes || [],
        });
        if (projectedDiscountsState.requires_update) {
            suppressionDiscount = projectedDiscountsState.discount_string || '';
        }
    }

    const requests = formatCartMutationRequestsForDispatch(plan.requestsByType, {
        cart: context.cart,
        attributes: nextAttributes,
        discount: suppressionDiscount !== undefined ? suppressionDiscount : discount,
    });

    return {
        ...plan,
        requires_intercept: plan.requires_intercept || shouldClearPreorderAttr || suppressionDiscount !== undefined,
        suppression_discount: suppressionDiscount,
        requests,
        totalRequestCount: countTotalRequests(plan.requestsByType),
    };
}

function projectCartMutationState(cartItems = [], modifications = [], options = {}) {
    const nextItems = recompileNextCart(cartItems, modifications);
    const nextState = buildNextMutationState(nextItems, options);

    return {
        nextItems,
        nextState,
    };
}

function createCartMutationSimulationMods(requestsByType = {}) {
    const mods = [
        ...(Array.isArray(requestsByType.updates) ? requestsByType.updates : []),
        ...(Array.isArray(requestsByType.changes) ? requestsByType.changes : []),
    ];

    if (Array.isArray(requestsByType.adds) && requestsByType.adds.length > 0) {
        mods.push({ type: 'add', body: { items: requestsByType.adds } });
    }

    return mods;
}

function checkShouldClearPreorderAttr(cart = {}, nextItems = []) {
    return cart?.attributes?._preorder === 'true'
        && Array.isArray(nextItems)
        && nextItems.length === 0;
}

function checkShouldHideGifts(cart = {}, nextItems = []) {
    return document.querySelector(SELECTORS.cartGiftDisplay) !== null
        && Array.isArray(nextItems)
        && nextItems.length === 0 ? true : false;
}

function normalizeCartUpdateLine(update = {}, cartItems = []) {
    const key = update.key || update.id || null;
    if (!key) return null;

    const existingLine = findCartLineForUpdate(key, cartItems);
    return {
        key,
        variant_id: util.normalize.number(update.variant_id)
            || util.normalize.number(existingLine?.variant_id)
            || parseVariantIdFromLineKey(key),
        quantity: util.normalize.number(update.quantity, { fallback: 0 }),
    };
}

function findCartLineForUpdate(key, cartItems = []) {
    const lineByKey = findCartLineByKey(key, cartItems);
    if (lineByKey) return lineByKey;

    const variantId = util.normalize.number(key);
    if (!variantId || !Array.isArray(cartItems)) return null;

    return cartItems.find(item => (
        !parseIsGift(item)
        && util.normalize.number(item.variant_id || item.id) === variantId
    )) || null;
}

function parseMutationPayloadInput(submitter = null, formData = null) {
    if (formData instanceof FormData) return parseMutationFormData(formData);
    return extractCartMutationPayload(submitter);
}

function parseMutationFormData(formData) {
    const out = {};

    Array.from(formData.entries()).forEach(([key, value]) => {
        if (key.startsWith('attributes[')) {
            const extractedKey = key.replace(/^attributes\[|\]$/g, '');
            if (!out.attributes) out.attributes = {};
            out.attributes[extractedKey] = value;
            return;
        }

        if (key.startsWith('attrs[')) {
            const extractedKey = key.replace(/^attrs\[|\]$/g, '');
            if (!out.attributes) out.attributes = {};
            out.attributes[extractedKey] = value;
            return;
        }

        if (key.startsWith('properties[')) {
            const extractedKey = key.replace(/^properties\[|\]$/g, '');
            if (!out.properties) out.properties = {};
            out.properties[extractedKey] = value;
            return;
        }

        if (key.startsWith('updates[')) {
            const extractedKey = key.replace(/^updates\[|\]$/g, '');
            if (!out.updates) out.updates = {};
            out.updates[extractedKey] = value;
            return;
        }

        out[key] = value;
    });

    return out;
}

function extractCartMutationPayload(options = {}) {
    if (options?.body?.payload) return options.body.payload;
    if (options?.payload) return options.payload;
    if (options?.body) return options.body;
    return options || {};
}

function compileCartMutationConsequences(requestsByType, projection, options = {}) {
    let recompiledProjection = projection;
    const currentUpdates = Array.isArray(options.currentUpdates) ? options.currentUpdates : [];
    const preorderRecompiled = parseProjectedPreorderLineChanges(
        recompiledProjection.nextState,
        recompiledProjection.nextItems
    );
    if (preorderRecompiled.length > 0) {
        mergeManagedLineChanges(requestsByType, preorderRecompiled);
        recompiledProjection = projectCartMutationState(
            recompiledProjection.nextItems,
            preorderRecompiled,
            {
                preorderActive: recompiledProjection.nextState.broad.preorder_active,
            }
        );
    }

    const propsRecompiled = recompileLineProps(
        recompiledProjection.nextState,
        currentUpdates,
        recompiledProjection.nextItems
    );

    if (propsRecompiled.length > 0) {
        mergeManagedLineChanges(requestsByType, propsRecompiled);
        recompiledProjection = projectCartMutationState(
            recompiledProjection.nextItems,
            propsRecompiled,
            {
                preorderActive: recompiledProjection.nextState.broad.preorder_active,
            }
        );
    }

    const giftMods = parseGiftsState(window.config.params, { items: recompiledProjection.nextItems });
    if (giftMods.requires_update) {
        if (giftMods.updates && Object.keys(giftMods.updates).length > 0) {
            Object.entries(giftMods.updates).forEach(([key, quantity]) => {
                requestsByType.updates.push({ type: 'update', body: { key, quantity } });
            });
        }
        if (giftMods.additions?.length > 0) requestsByType.adds.push(...giftMods.additions);
    }

    return {
        requestsByType,
        requires_intercept: preorderRecompiled.length > 0
            || propsRecompiled.length > 0
            || giftMods.requires_update === true,
    };
}

function parseProjectedPreorderLineChanges(nextState, nextItems = []) {
    const activeDiscounts = nextState.broad?.applicable_discounts || [];
    const rules = window.config?.params?.preorder_rules || [];
    const nextEligible = rules.length > 0;
    const nextActive = nextState.broad?.preorder_active === true;

    return parsePreorderChanges(
        nextItems.filter(item => item.key),
        activeDiscounts,
        rules,
        nextEligible,
        nextActive
    ).map(change => ({
        type: 'change',
        body: {
            key: change.key || change.id,
            variant_id: change.variant_id,
            quantity: change.quantity,
            properties: change.properties || {},
        },
    })).filter(change => change.body.key);
}

function buildNextMutationState(nextItems = [], options = {}) {
    const applicableDiscounts = parseActiveDiscounts(window.config.params.discounts, nextItems) || [];
    const preorderRules = extractParamMatches(
        applicableDiscounts,
        'preorder_rules',
        'id',
        window.config?.params?.preorder_rules,
        'id'
    );

    return {
        broad: {
            cart_items: nextItems,
            applicable_discounts: applicableDiscounts,
            preorder_rules: preorderRules,
            preorder_active: options.preorderActive !== undefined
                ? options.preorderActive
                : window.config?.state?.active_preorder === true
                || window.config?.params?.attributes?._preorder === 'true',
            price_overrides: extractParamMatches(
                applicableDiscounts,
                'variant_price_overrides',
                'id',
                window.config?.params?.variant_price_overrides,
                'id'
            ),
        },
    };
}

function mergeManagedLineChanges(requestsByType, managedChanges = []) {
    managedChanges.forEach(change => {
        const body = change.body || change;
        const key = body.key;
        if (!key) return;

        const existingChange = requestsByType.changes.find(item => item.body?.key === key);
        if (existingChange) {
            existingChange.body = {
                ...existingChange.body,
                variant_id: existingChange.body.variant_id || body.variant_id,
                quantity: existingChange.body.quantity !== undefined
                    ? existingChange.body.quantity
                    : body.quantity,
                properties: body.properties || {},
            };
            return;
        }

        const updateIndex = requestsByType.updates.findIndex(item => item.body?.key === key);
        if (updateIndex > -1) {
            const update = requestsByType.updates[updateIndex];
            if (update.body.quantity <= 0) return;

            requestsByType.updates.splice(updateIndex, 1);
            requestsByType.changes.push({
                type: 'change',
                body: {
                    key,
                    variant_id: update.body.variant_id || body.variant_id,
                    quantity: update.body.quantity,
                    properties: body.properties || {},
                },
            });
            return;
        }

        requestsByType.changes.push(change);
    });
}

function formatCartMutationRequestsForDispatch(requestsByType = {}, options = {}) {
    return orchestrateRequests({
        adds: requestsByType.adds || [],
        changes: requestsByType.changes || [],
        updates: requestsByType.updates || [],
        attributes: options.attributes || {},
        discount: options.discount,
        cart: options.cart || parseCurrentCart(),
        discounts: window.config?.params?.discounts || [],
    });
}

function recompileLineProps(nextState, currentUpdates = [], nextItems = []) {
    const preorderActive = nextState.broad.preorder_rules?.length > 0 && nextState.broad.preorder_active === true ? true : false;
    const touchedByKey = new Map();
    const changes = [];

    currentUpdates.forEach(update => {
        const body = update?.body || update;
        if (body?.key) touchedByKey.set(body.key, body);
    });
    
    const considered = nextItems.filter(item => item.key && !parseIsGift(item));

    considered.forEach(item => {
        const hydratedNextItem = parseNextRequestItemState(
            util.normalize.number(item.variant_id || item.id),
            nextState.broad.applicable_discounts
        );
        const localOriginalPrice = parseLineOriginalPrice(item);
        const requiredProps = parseAddRequestProps(hydratedNextItem, {
            preorderContext: preorderActive,
            local_original_price: localOriginalPrice,
        });
        const nextProperties = reconcileManagedLineProps(item.properties || {}, requiredProps, {
            hasPriceOverride: !!hydratedNextItem?.price_override,
            hasPreorderRule: !!hydratedNextItem?.preorder_rule,
            preorderActive,
        });

        const touched = touchedByKey.get(item.key);
        if (
            touched?.properties !== undefined
            && util.compare.object.equal(touched.properties || {}, nextProperties, { loose: true })
        ) return;
        if (util.compare.object.equal(item.properties || {}, nextProperties, { loose: true })) return;

        changes.push({
            type: 'change',
            body: {
                key: item.key,
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: nextProperties,
            },
        });
    });

    return changes;
}

function parseLineOriginalPrice(item) {
    const properties = item?.properties || {};
    const localOriginalPrice = util.normalize.number(properties._local_original_price);
    if (localOriginalPrice) return localOriginalPrice * 100;

    const preorderOriginalMsrp = util.normalize.number(properties._preorder_original_msrp);
    if (preorderOriginalMsrp) return preorderOriginalMsrp * 100;

    const hasManagedPrice = properties._isPreorder === 'true'
        || properties._isPreorder === true
        || properties._transformed_at_once != null;
    if (hasManagedPrice) return null;

    return item?.original_price || item?.price || null;
}

function reconcileManagedLineProps(currentProperties = {}, requiredProps = {}, context = {}) {
    const { hasPriceOverride = false, hasPreorderRule = false, preorderActive = false } = context;
    const out = { ...currentProperties };

    if (requiredProps._local_original_price != null) {
        out._local_original_price = requiredProps._local_original_price;
    }

    if (hasPriceOverride && requiredProps._transformed_at_once != null) {
        out._transformed_at_once = requiredProps._transformed_at_once;
    } else {
        delete out._transformed_at_once;
    }

    if (preorderActive && hasPreorderRule) {
        PREORDER_LINE_PROPS.forEach(prop => {
            if (requiredProps[prop] != null) out[prop] = requiredProps[prop];
        });
    } else {
        PREORDER_LINE_PROPS.forEach(prop => {
            delete out[prop];
        });
    }

    return out;
}

function countTotalRequests(requests = { updates: [], changes: [], adds: [] }) {
    let count = 0;
    if (requests.updates.length > 0) count += 1;
    if (requests.changes.length > 0) count += requests.changes.length;
    if (requests.adds.length > 0) count += 1;
    return count;
}

function recompileNextCart(nextCartItems, modifications) {
    const items = nextCartItems.map(item => ({ ...item }));
    modifications.forEach(mod => {
        if (mod.type === 'update' || mod.type === 'change') {
            // Remove the early "temp item" that was added to the payload for early parsing.
            const matchedTemp = items.find(item => !item.key && item.id === mod.body.temp_variant_id);
            if (matchedTemp) items.splice(items.indexOf(matchedTemp), 1);

            const matchedExisting = findNextCartMutationLine(items, mod);
            if (matchedExisting) {
                if (mod.body.quantity !== undefined) matchedExisting.quantity = mod.body.quantity;
                if (matchedExisting.quantity <= 0) {
                    items.splice(items.indexOf(matchedExisting), 1);
                    return;
                }
                if (mod.body.properties !== undefined) matchedExisting.properties = mod.body.properties || {};
                if (mod.body.selling_plan !== undefined) {
                    matchedExisting.selling_plan = mod.body.selling_plan;
                    matchedExisting.selling_plan_id = mod.body.selling_plan;
                }
            }
        } else if (mod.type === 'add') {
            mod.body.items.forEach(nextItem => {
                const matchedTemp = items.find(item => !item.key && item.temp === true && item.id === nextItem.id);
                if (matchedTemp) items.splice(items.indexOf(matchedTemp), 1);
                items.push(nextItem);
            })
        }
    });

    return items;
}

function findNextCartMutationLine(items = [], mod = {}) {
    const body = mod.body || {};
    const lineByKey = items.find(item => item.key === body.key);
    if (lineByKey) return lineByKey;
    if (mod.type !== 'update') return null;

    const variantId = util.normalize.number(body.variant_id) || util.normalize.number(body.key);
    if (!variantId) return null;

    return items.find(item => (
        !parseIsGift(item)
        && util.normalize.number(item.variant_id || item.id) === variantId
    )) || null;
}

function mergeLinePayloads(compareLines, context) {
    const modifyLines = compareLines.modify_lines
    const merged = []

    modifyLines.forEach(line => {
        const modsRequired = {
            quantity: false,
            properties: false,
        }
        switch (context) {
            case 'add':
                modsRequired.quantity = true;
                const targetQuantity = line.next.quantity + line.line.quantity;

                const propsMatch = util.compare.object.equal(line.next.properties, line.line.properties, { loose: true })
                if (!propsMatch) modsRequired.properties = true;

                if (propsMatch) {
                    merged.push({
                        type: 'update',
                        body: {
                            key: line.line.key,
                            quantity: targetQuantity,
                            temp_variant_id: line.next.id
                        }
                    });
                } else {
                    merged.push({
                        type: 'change',
                        body: {
                            key: line.line.key,
                            quantity: targetQuantity,
                            properties: line.next.properties,
                            temp_variant_id: line.next.id
                        }
                    });
                }
                break;
            case 'change':
                targetQuantity = linesExist.next.quantity;
                break;
            default:
                break;
        }

    });
    
    return merged;
}

function extractFormDataValues(formData, keys = [], formatters = {}, fallbacks = {}) {
    const out = {};
    if (!formData || !(formData instanceof FormData) || !Array.isArray(keys) || keys.length === 0) return out;

    const dataObj = Array.from(formData.entries())

    keys.forEach(key => {
        const exists = dataObj.find(entry => entry[0] === key || entry[0].startsWith('properties[_') && entry[0].includes(key));
        const formatType = formatters[key] || 'exact';
        const fallback = fallbacks[key] || null;
        if (!exists && !fallback) return;
        
        if (exists) {
            switch (formatType) {
                case 'number':
                    out[key] = util.normalize.number(exists[1]);
                    break;
                case 'boolean':
                    out[key] = util.normalize.boolean(exists[1]);
                    break;
                default:
                    out[key] = exists[1];
                    break;
            }
        } else {
            out[key] = fallback;
        }
    });
    return out;
}

function parseApplicableActiveDiscount(variantId) {
    const activeDiscounts = window.config.state.active_discounts || []
    if (!activeDiscounts.length) return null;

    const applicableDiscounts = activeDiscounts.filter(d => d.variant_ids.includes(variantId));
    if (!applicableDiscounts.length) return null;
    if (applicableDiscounts.length === 1) return applicableDiscounts[0];

    return applicableDiscounts.reduce((best, discount) => {
        if (!best) return discount;
        return discount.amount > best.amount ? discount : best;
    }, null);
}

function reparseAddRequest(requestItems, nextCartItems) {
    const out = { matches_exist: false, modify_lines: [], add_lines: [] };

    const existingLines = nextCartItems.filter(item => item.key)
    if (!existingLines.length) {
        requestItems.forEach(item => {
            out.add_lines.push(item);
        });
        return out;
    };

    const existingNonGift = applyNonGiftItemFilter(existingLines);
    requestItems.forEach(item => {
        const exists = existingNonGift.find(
            line => (
                util.normalize.number(line.id) === item.id
                || util.normalize.number(line.variant_id) === item.id
            ) && checkSellingPlanMatches(line, item)
        );
        if (exists) {
            out.matches_exist = true;
            out.modify_lines.push({
                next: item,
                line: exists,
            });
        } else {
            out.add_lines.push(item);
        }
    });

    return out;
}

function checkSellingPlanMatches(line = {}, item = {}) {
    const lineSellingPlan = parseSellingPlanId(line);
    const itemSellingPlan = parseSellingPlanId(item);

    return lineSellingPlan === itemSellingPlan;
}

function parseSellingPlanId(item = {}) {
    return util.normalize.number(item.selling_plan)
        || util.normalize.number(item.selling_plan_id)
        || util.normalize.number(item.selling_plan_allocation?.selling_plan?.id)
        || null;
}

function parseAddRequestProps(nextItem, details = {}) {
    const out = {}
    if (!nextItem) return out;

    const hasPreorderContext = Object.prototype.hasOwnProperty.call(details, 'preorderContext');
    const preorderContext = hasPreorderContext
        ? details.preorderContext === true
        : window.config.params.attributes?._preorder === 'true';
    const { local_original_price = null } = details;
    const { applicable_discount, preorder_rule, price_override } = nextItem;

    if (local_original_price != null) {
        out._local_original_price = local_original_price / 100;
    }
    // PARSE PREORDER PROPS
    if (preorderContext && preorder_rule && applicable_discount) {
        out._isPreorder = 'true';
        out._preorder_price = parseOriginalFromDiscount(preorder_rule.price_preorder.amount, applicable_discount.method, applicable_discount.amount) / 100;
        out._preorder_market_currency = window.localeDetails?.currency?.iso_code || 'USD';
        out._added_in_market = window.localeDetails?.market || 'us';
        if (local_original_price != null) {
            out._preorder_discount_rate = parseActiveDiscountRate(preorder_rule.price_preorder.amount, local_original_price);
            out._preorder_original_msrp = local_original_price / 100;
        }
    }
    // PARSE PRICE OVERRIDE PROPS
    if (price_override && applicable_discount) {
        out._transformed_at_once = parseOriginalFromDiscount(price_override.price.amount, applicable_discount.method, applicable_discount.amount) / 100;
    }
    return out;
}

/* ------------------------------------------------------------------------ */

/* REQUEST ORCHESTRATION */

/* ------------------------------------------------------------------------ */

function orchestrateRequests(rawPlan = {}) {
    const plan = normalizeRequestPlan(rawPlan);
    const requests = [];

    const addRequest = buildAddRequest(plan);
    const identityChanges = plan.changes.filter(change => checkChangeMutatesLineKey(change));
    const identityReplacementRequests = identityChanges.length > 1
        && checkCanReplaceIdentityChanges(identityChanges)
        ? buildIdentityChangeReplacementRequests(identityChanges)
        : [];
    const identityChangeRequests = identityReplacementRequests.length
        ? []
        : identityChanges.map(change => buildChangeRequest(change));
    const standardChangeRequests = plan.changes
        .filter(change => !checkChangeMutatesLineKey(change))
        .map(change => buildChangeRequest(change));
    const updateRequest = buildUpdateRequest(plan);

    if (checkCanAddFirst(plan)) {
        if (addRequest) requests.push(addRequest);
        if (identityChangeRequests.length) requests.push(...identityChangeRequests);
        if (updateRequest) requests.push(updateRequest);
        if (standardChangeRequests.length) requests.push(...standardChangeRequests);
    } else {
        if (identityReplacementRequests[0]) requests.push(identityReplacementRequests[0]);
        if (identityChangeRequests.length) requests.push(...identityChangeRequests);
        if (updateRequest) requests.push(updateRequest);
        if (standardChangeRequests.length) requests.push(...standardChangeRequests);
        if (identityReplacementRequests[1]) requests.push(identityReplacementRequests[1]);
        if (addRequest) requests.push(addRequest);
    }

    attachSectionsToLastRequest(requests);
    return requests;
}

function normalizeRequestPlan(rawPlan = {}) {
    const cartItems = Array.isArray(rawPlan.cart?.items) ? rawPlan.cart.items : [];
    const attributes = rawPlan.attributes || {};
    const discount = rawPlan.discount;
    const adds = Array.isArray(rawPlan.adds) ? rawPlan.adds : [];
    const changes = Array.isArray(rawPlan.changes)
        ? rawPlan.changes.map(change => normalizeChange(change, cartItems)).filter(Boolean)
        : [];
    const updates = Array.isArray(rawPlan.updates)
        ? rawPlan.updates.map(update => normalizeUpdate(update, cartItems)).filter(Boolean)
        : [];

    return {
        adds,
        changes,
        updates,
        attributes,
        discount,
        cartItems,
        discounts: Array.isArray(rawPlan.discounts) ? rawPlan.discounts : [],
    };
}

function normalizeChange(change, cartItems = []) {
    const body = change?.body || change;
    if (!body?.key) return null;

    const existingLine = findCartLineByKey(body.key, cartItems);
    return {
        key: body.key,
        variant_id: util.normalize.number(body.variant_id)
            || util.normalize.number(existingLine?.variant_id)
            || parseVariantIdFromLineKey(body.key),
        ...(body.quantity !== undefined ? { quantity: body.quantity } : {}),
        ...(body.properties !== undefined ? { properties: body.properties } : {}),
        ...(body.selling_plan !== undefined ? { selling_plan: body.selling_plan } : {}),
    };
}

function normalizeUpdate(update, cartItems = []) {
    const body = update?.body || update;
    if (!body?.key) return null;

    const existingLine = findCartLineByKey(body.key, cartItems);
    return {
        key: body.key,
        variant_id: util.normalize.number(body.variant_id)
            || util.normalize.number(existingLine?.variant_id)
            || parseVariantIdFromLineKey(body.key),
        quantity: body.quantity,
    };
}

function buildAddRequest(plan) {
    if (!plan.adds.length) return null;
    const hasUpdateRequest = plan.updates.length > 0 || plan.discount !== undefined;

    const payload = {
        items: plan.adds,
    };

    if (!hasUpdateRequest && Object.keys(plan.attributes || {}).length > 0) {
        payload.attributes = plan.attributes;
    }

    return {
        method: 'add',
        payload,
    };
}

function buildChangeRequest(change) {
    return {
        method: 'change',
        payload: parseChangePayloadBody(change, 'change'),
    };
}

function buildIdentityChangeReplacementRequests(changes = []) {
    const removals = {};
    const additions = [];

    changes.forEach(change => {
        removals[change.key] = 0;
        if (change.quantity <= 0) return;
        additions.push(parseChangePayloadBody(change, 'add'));
    });

    return [
        Object.keys(removals).length > 0
            ? {
                method: 'update',
                payload: { updates: removals },
            }
            : null,
        additions.length > 0
            ? {
                method: 'add',
                payload: { items: additions },
            }
            : null,
    ];
}

function checkCanReplaceIdentityChanges(changes = []) {
    return changes.every(change => (
        change.key
        && (
            util.normalize.number(change.quantity) <= 0
            || (
                change.variant_id
                && util.normalize.number(change.quantity) > 0
            )
        )
    ));
}

function buildUpdateRequest(plan) {
    const payload = {};

    if (plan.updates.length > 0) {
        payload.updates = {};
        plan.updates.forEach(update => {
            payload.updates[update.key] = update.quantity;
        });
    }

    if (
        (!plan.adds.length || plan.updates.length > 0 || plan.discount !== undefined)
        && Object.keys(plan.attributes || {}).length > 0
    ) {
        payload.attributes = plan.attributes;
    }

    if (plan.discount !== undefined) {
        payload.discount = plan.discount;
    }

    if (!Object.keys(payload).length) return null;

    return {
        method: 'update',
        payload,
    };
}

function checkCanAddFirst(plan) {
    if (!plan.adds.length) return false;

    const keyedMutations = [...plan.changes, ...plan.updates];
    if (!keyedMutations.length) return true;
    if (plan.changes.some(change => checkChangeMutatesLineKey(change))) return false;
    if (keyedMutations.some(mutation => !mutation.variant_id)) return false;
    if (checkPlanHasTieredDiscountRisk(plan, keyedMutations)) return false;

    return true;
}

function checkChangeMutatesLineKey(change) {
    return change.properties !== undefined || change.selling_plan !== undefined;
}

function checkPlanHasTieredDiscountRisk(plan, keyedMutations = []) {
    const affectedVariantIds = new Set();

    keyedMutations.forEach(mutation => {
        const variantId = util.normalize.number(mutation.variant_id);
        if (variantId) affectedVariantIds.add(variantId);
    });

    plan.adds.forEach(item => {
        const variantId = util.normalize.number(item.id || item.variant_id);
        if (variantId) affectedVariantIds.add(variantId);
    });

    for (const variantId of affectedVariantIds) {
        if (checkVariantHasTieredDiscounts(variantId, plan.discounts)) return true;
    }

    return false;
}

function checkVariantHasTieredDiscounts(variantId, discounts = []) {
    const id = util.normalize.number(variantId);
    if (!id || !Array.isArray(discounts)) return false;

    return discounts.filter(discount => (
        Array.isArray(discount.variant_ids)
        && discount.variant_ids.includes(id)
    )).length > 1;
}

function findCartLineByKey(key, cartItems = []) {
    if (!key || !Array.isArray(cartItems)) return null;
    return cartItems.find(item => item.key === key) || null;
}

function parseVariantIdFromLineKey(key) {
    if (!key || typeof key !== 'string') return null;
    return util.normalize.number(key.split(':')[0]);
}

function attachSectionsToLastRequest(requests = []) {
    const last = requests[requests.length - 1];
    if (!last) return;

    attachSectionsToRequest(last, createCartRequestSectionPlan().bundled);
}

function getCurrentSectionsUrl() {
    return `${window.location.pathname}${window.location.search || ''}`;
}

/* ------------------------------------------------------------------------ */
/* LEGACY CART CONVERSION - REMOVE AFTER DEPLOY TRANSITION WINDOW */
/* ------------------------------------------------------------------------ */

async function handleLegacyCartConversion() {
    if (window.legacyCartConversionRequired !== true) return false;
    if (checkIsOfferPage()) return false;

    startLegacyCartConversionUi();

    try {
        const cart = await cartFetch('get', {});
        if (!checkShouldConvertLegacyCart(cart)) {
            endLegacyCartConversionUi();
            return false;
        }

        const offerHandle = parseLegacyCartOfferHandle(cart);
        if (!offerHandle) {
            endLegacyCartConversionUi();
            return false;
        }
        const legacyDiscountCodes = parseLegacyCartDiscountCodes(cart)
            .filter(code => parseOfferFromCode(code) === offerHandle);

        const offeredCart = await dispatchLegacyOfferHandleUpdate(cart, offerHandle);
        if (!offeredCart) {
            endLegacyCartConversionUi();
            return false;
        }

        const validation = handleShadowValidation(offeredCart.sections);
        if (!validation.valid || validation.offer_exists !== true) {
            endLegacyCartConversionUi();
            return false;
        }
        const discountCodes = legacyDiscountCodes.length
            ? legacyDiscountCodes
            : parseLegacyConfigDiscountCodes(validation.config);

        const replacementPlan = parseLegacyReplacementPlan(offeredCart, validation.config);
        if (!replacementPlan.removals.length && !replacementPlan.additions.length) {
            endLegacyCartConversionUi();
            return false;
        }

        const baseAttributes = {
            _offer_handle: offerHandle,
            _offer_applied_ts: parseCurrentTs(),
            ...parseLegacyPreorderCartAttributes(validation.config || {}, offeredCart),
        };

        const removedCart = await dispatchLegacyManagedLineRemoval(
            replacementPlan.removals,
            baseAttributes
        );
        if (!removedCart) {
            endLegacyCartConversionUi();
            return false;
        }

        const finalCart = replacementPlan.additions.length
            ? await dispatchLegacyReplacementAdditions(replacementPlan.additions)
            : removedCart;
        if (!finalCart) {
            endLegacyCartConversionUi();
            return false;
        }

        const stampedCart = await dispatchLegacyFinalCartState(baseAttributes, discountCodes);
        if (!stampedCart) {
            endLegacyCartConversionUi();
            return false;
        }

        const verifiedCart = await cartFetch('get', {});
        if (!checkLegacyCartConversionVerified(verifiedCart, offerHandle, discountCodes)) {
            endLegacyCartConversionUi();
            return false;
        }

        updateLegacyCartConversionMessage('Yep you\'ve got it!');
        window.setTimeout(() => window.location.reload(), LEGACY_CART_CONVERSION_SUCCESS_DELAY_MS);
        return true;
    } catch (error) {
        console.warn('[OfferEngine] Legacy cart conversion skipped', error);
        endLegacyCartConversionUi();
        return false;
    }
}

function checkShouldConvertLegacyCart(cart = {}) {
    if (!cart || typeof cart !== 'object') return false;

    return parseLegacyCartOfferHandle(cart) !== null || checkLegacyCartHasManagedLines(cart);
}

function parseLegacyCartOfferHandle(cart = {}) {
    const currentOfferHandle = util.normalize.text(cart?.attributes?._offer_handle || '');
    if (currentOfferHandle) return currentOfferHandle;

    const codes = parseLegacyCartDiscountCodes(cart);

    for (const code of codes) {
        const offerHandle = parseOfferFromCode(code);
        if (offerHandle) return offerHandle;
    }

    return null;
}

function parseLegacyCartDiscountCodes(cart = {}) {
    const codes = [];
    const pushCode = (value) => {
        const normalized = util.normalize.text(value).toLowerCase();
        if (normalized && !codes.includes(normalized)) codes.push(normalized);
    };

    if (Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(discount => pushCode(discount?.code || discount));
    }

    if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
            if (Array.isArray(item?.discounts)) {
                item.discounts.forEach(discount => pushCode(discount?.title));
            }

            if (Array.isArray(item?.line_level_discount_allocations)) {
                item.line_level_discount_allocations.forEach((allocation) => {
                    pushCode(allocation?.discount_application?.title);
                });
            }
        });
    }

    return codes;
}

function parseLegacyConfigDiscountCodes(config = {}) {
    if (!Array.isArray(config.discounts)) return [];

    return config.discounts
        .map(discount => util.normalize.text(discount?.title || '').toLowerCase())
        .filter(Boolean);
}

function checkLegacyCartHasManagedLines(cart = {}) {
    return Array.isArray(cart.items) && cart.items.some(item => checkLegacyLineHasManagedProps(item));
}

function checkLegacyCartHasPreorderLines(cart = {}) {
    return Array.isArray(cart.items) && cart.items.some(item => checkLegacyLineIsPreorder(item));
}

function checkLegacyLineHasManagedProps(item = {}) {
    const properties = item.properties || {};
    return checkLegacyLineIsGift(item)
        || checkLegacyLineIsPreorder(item)
        || Object.keys(properties).some(key => checkShouldDropLegacyLineProp(key));
}

function checkLegacyLineHasOldProps(item = {}) {
    const properties = item.properties || {};
    return properties.is_gift === true
        || properties.is_gift === 'true'
        || Object.keys(properties).some(key => checkShouldDropLegacyLineProp(key));
}

function checkLegacyLineIsGift(item = {}) {
    const properties = item.properties || {};
    return properties.is_gift === true
        || properties.is_gift === 'true'
        || properties._is_gift === true
        || properties._is_gift === 'true';
}

function checkLegacyLineIsPreorder(item = {}) {
    const value = item.properties?._isPreorder;
    return value === true || value === 'true';
}

function parseLegacyPreorderOriginalMsrp(properties = {}) {
    const centsValue = util.normalize.number(properties._unlocalized_msrp);
    if (Number.isFinite(centsValue) && centsValue > 0) {
        return parseFloat((centsValue / 100).toFixed(2));
    }

    const displayValue = properties._original_msrp;
    if (displayValue == null) return null;

    const parsed = Number(String(displayValue).replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function checkShouldDropLegacyLineProp(key) {
    return LEGACY_LINE_PROP_DROPS.includes(key)
        || String(key || '').startsWith('_offer_line_items_');
}

async function dispatchLegacyOfferHandleUpdate(cart = {}, offerHandle = null) {
    if (!offerHandle) return null;

    const payload = {
        attributes: {
            _offer_handle: offerHandle,
        },
        sections: resolveSectionInputs(['offer_config']),
        sections_url: getCurrentSectionsUrl(),
    };

    return await cartFetch('update', payload);
}

function parseLegacyReplacementPlan(cart = {}, config = {}) {
    const items = Array.isArray(cart.items) ? cart.items : [];
    const removals = items.filter(item => checkLegacyLineRequiresReplacement(item));
    const paidRemovals = removals.filter(item => !checkLegacyLineIsGift(item));
    const preorderActive = paidRemovals.some(item => checkLegacyLineIsPreorder(item));
    const activeDiscounts = parseActiveDiscounts(
        config.discounts || [],
        items.filter(item => !checkLegacyLineIsGift(item))
    );
    const simulatedPaidItems = [
        ...items.filter(item => !removals.some(removal => removal.key === item.key)),
        ...paidRemovals.map(item => (
            parseLegacyReplacementSimulationItem(item, config, preorderActive, activeDiscounts)
        )),
    ].filter(Boolean);
    const giftAdditions = parseLegacyGiftAdditions({
        ...cart,
        items: simulatedPaidItems,
    }, config);

    return {
        removals,
        additions: [
            ...paidRemovals.map(item => (
                parseLegacyReplacementAddItem(item, config, preorderActive, activeDiscounts)
            )),
            ...giftAdditions,
        ].filter(Boolean),
    };
}

function checkLegacyLineRequiresReplacement(item = {}) {
    const properties = item.properties || {};
    return checkLegacyLineIsGift(item)
        || checkLegacyLineIsPreorder(item)
        || properties._transformed_at_once != null
        || properties._adjusted_variant_price != null
        || Object.keys(properties).some(key => checkShouldDropLegacyLineProp(key));
}

function parseLegacyReplacementSimulationItem(
    item = {},
    config = {},
    preorderActive = false,
    activeDiscounts = []
) {
    const addItem = parseLegacyReplacementAddItem(item, config, preorderActive, activeDiscounts);
    if (!addItem) return null;

    return {
        ...item,
        id: addItem.id,
        variant_id: addItem.id,
        quantity: addItem.quantity,
        properties: addItem.properties || {},
        ...(addItem.selling_plan ? { selling_plan: addItem.selling_plan } : {}),
    };
}

function parseLegacyReplacementAddItem(
    item = {},
    config = {},
    preorderActive = false,
    activeDiscounts = []
) {
    const variantId = util.normalize.number(item.variant_id || item.id);
    const quantity = util.normalize.number(item.quantity, { fallback: 1 });
    if (!variantId || quantity <= 0) return null;

    const nextItem = parseNextRequestItemState(variantId, activeDiscounts, config);
    const requiredProps = parseAddRequestProps(nextItem, {
        preorderContext: preorderActive,
        local_original_price: parseLegacyManagedLineOriginalPrice(item),
    });
    const cleanProps = parseLegacyCleanBaseLineProperties(item.properties || {});

    return {
        id: variantId,
        quantity,
        properties: {
            ...cleanProps,
            ...requiredProps,
        },
        ...(item.selling_plan ? { selling_plan: item.selling_plan } : {}),
        ...(item.selling_plan_id ? { selling_plan: item.selling_plan_id } : {}),
    };
}

function parseLegacyCleanBaseLineProperties(properties = {}) {
    const out = {};

    Object.entries(properties).forEach(([key, value]) => {
        if (checkShouldDropLegacyLineProp(key)) return;
        if (PREORDER_LINE_PROPS.includes(key)) return;
        if (key === '_is_gift') return;
        if (key === '_transformed_at_once') return;
        if (key === '_adjusted_variant_price') return;
        if (key === '_local_original_price') return;
        out[key] = value;
    });

    return out;
}

function parseLegacyManagedLineOriginalPrice(item = {}) {
    const properties = item.properties || {};
    const preorderOriginalMsrp = util.normalize.number(properties._preorder_original_msrp);
    if (preorderOriginalMsrp) return preorderOriginalMsrp * 100;

    const unlocalizedMsrp = util.normalize.number(properties._unlocalized_msrp);
    if (unlocalizedMsrp) return unlocalizedMsrp;

    const originalMsrp = parseLegacyPreorderOriginalMsrp(properties);
    if (originalMsrp) return originalMsrp * 100;

    const localOriginalPrice = util.normalize.number(properties._local_original_price);
    if (localOriginalPrice) return localOriginalPrice * 100;

    return item.original_price || item.price || null;
}

function parseLegacyGiftAdditions(cart = {}, config = {}) {
    const giftState = parseGiftsState(config, cart);
    return Array.isArray(giftState.additions) ? giftState.additions : [];
}

async function dispatchLegacyManagedLineRemoval(removals = [], attributes = {}) {
    const updates = {};
    removals.forEach((item) => {
        if (item.key) updates[item.key] = 0;
    });

    return await cartFetch('update', {
        updates,
        attributes,
    });
}

async function dispatchLegacyReplacementAdditions(additions = []) {
    if (!additions.length) return null;

    return await cartFetch('add', {
        items: additions,
    });
}

async function dispatchLegacyFinalCartState(attributes = {}, discountCodes = []) {
    return await cartFetch('update', {
        attributes: {
            ...attributes,
            [LEGACY_CART_CONVERSION_ATTR]: LEGACY_CART_CONVERSION_VALUE,
        },
        ...(discountCodes.length ? { discount: Array.from(new Set(discountCodes)).join(',') } : {}),
    });
}

function checkLegacyCartConversionVerified(cart = {}, offerHandle = null, discountCodes = []) {
    if (!cart || typeof cart !== 'object') return false;
    if (cart.attributes?._offer_handle !== offerHandle) return false;
    if (cart.attributes?.[LEGACY_CART_CONVERSION_ATTR] !== LEGACY_CART_CONVERSION_VALUE) return false;
    if (Array.isArray(cart.items) && cart.items.some(item => checkLegacyLineHasOldProps(item))) return false;

    const requiredCodes = Array.from(new Set(discountCodes.filter(Boolean)));
    if (!requiredCodes.length) return true;

    const currentDiscounts = Array.isArray(cart.discount_codes)
        ? cart.discount_codes.map((discount) => ({
            code: util.normalize.text(discount?.code || discount).toLowerCase(),
            applicable: discount?.applicable,
        }))
        : [];

    return requiredCodes.every(code => (
        currentDiscounts.some(discount => discount.code === code && discount.applicable !== false)
    ));
}

function parseLegacyPreorderCartAttributes(config = {}, cart = {}) {
    if (!checkLegacyCartHasPreorderLines(cart)) return {};
    const rules = Array.isArray(config.preorder_rules) ? config.preorder_rules : [];
    if (!rules.length) return {};

    const discounts = Array.isArray(config.discounts) ? config.discounts : [];
    const activeDiscounts = Array.isArray(config.active_discounts) && config.active_discounts.length
        ? config.active_discounts
        : parseActiveDiscounts(discounts, cart.items || []);
    const activeRules = parseApplicablePreorderRules(rules, activeDiscounts, cart.items || []);
    const preorderState = parsePreorderRuleState(activeRules);
    if (!preorderState) return {};

    return {
        _preorder: 'true',
        _preorder_eligible: 'true',
        _preorder_ship_delay: preorderState.delay.toString(),
        _preorder_rules_ids: preorderState.ruleIds.join(','),
    };
}

function startLegacyCartConversionUi() {
    if (TRANSITION_UI_ACTIVE !== true) TRANSITION_UI_ACTIVE = true;
    startKlaviyoOfferBlocker(
        LEGACY_CART_CONVERSION_BLOCKER_HANDLE,
        LEGACY_CART_CONVERSION_BLOCKER_MS
    );

    legacyCartConversionTimers.forEach(timer => window.clearTimeout(timer));
    legacyCartConversionTimers = [];

    if (document.querySelector(`[${LEGACY_CART_CONVERSION_OVERLAY_ATTR}]`)) return;

    const overlay = document.createElement('div');
    overlay.setAttribute(LEGACY_CART_CONVERSION_OVERLAY_ATTR, '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-live', 'polite');
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.zIndex = '2147483647';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.padding = '24px';
    overlay.style.background = 'rgba(255, 255, 255, 0.86)';
    overlay.style.backdropFilter = 'blur(6px)';

    const dialog = document.createElement('div');
    dialog.style.display = 'grid';
    dialog.style.justifyItems = 'center';
    dialog.style.gap = '18px';
    dialog.style.width = 'min(100%, 420px)';
    dialog.style.padding = '12px';
    dialog.style.textAlign = 'center';

    const loader = document.createElement('div');
    loader.className = 'pending--loader';

    const message = document.createElement('h2');
    message.setAttribute(LEGACY_CART_CONVERSION_MESSAGE_ATTR, '');
    message.textContent = 'Just a second while we make sure you\'re getting our best deal 😄';
    message.style.margin = '0';
    message.style.color = 'var(--brand-color-1)';
    message.style.fontFamily = 'inherit';
    message.style.fontSize = 'clamp(2rem, 4vw, 3rem)';
    message.style.lineHeight = '1.35';
    message.style.fontWeight = '700';

    dialog.append(loader, message);
    overlay.append(dialog);
    document.body.append(overlay);

    legacyCartConversionTimers.push(window.setTimeout(() => {
        updateLegacyCartConversionMessage('Things are looking good, just double checking...');
    }, LEGACY_CART_CONVERSION_PROGRESS_MS));
}

function endLegacyCartConversionUi() {
    legacyCartConversionTimers.forEach(timer => window.clearTimeout(timer));
    legacyCartConversionTimers = [];

    const overlay = document.querySelector(`[${LEGACY_CART_CONVERSION_OVERLAY_ATTR}]`);
    if (overlay) overlay.remove();

    if (klaviyoOfferBlockerHandle === LEGACY_CART_CONVERSION_BLOCKER_HANDLE) {
        disposeKlaviyoOfferBlocker();
    }

    if (TRANSITION_UI_ACTIVE === true) TRANSITION_UI_ACTIVE = false;
}

function updateLegacyCartConversionMessage(message) {
    const messageEl = document.querySelector(`[${LEGACY_CART_CONVERSION_MESSAGE_ATTR}]`);
    if (!messageEl) return;
    messageEl.textContent = message;
}

/**
 * Open the optional upsell step using native modal and quantity controls.
 * The offer page supplies its existing summary, combined submission, and completion callbacks.
 * @returns {Promise<boolean>} Whether the upsell step handles completion.
 */
async function openOfferUpsell({ trigger, baseTotal, submit, complete, formatMoney, updateSummary, dismiss }) {
    const modal = document.querySelector(SELECTORS.offerUpsellModal);
    if (!modal || !modal.querySelector('[data-upsell-item]')) return false;
    if (activeOfferUpsell) return true;

    if (!Number.isFinite(baseTotal)) throw new Error('Unable to calculate offer total before opening upsells');
    const variantModal = trigger?.closest('custom-modal[data-modal-id="offer-variant-selection"]');
    await window.closeAllCustomModals?.({ exclude: variantModal || null, restoreFocus: false, clearUrl: true });
    activeOfferUpsell = { modal, submit, complete, formatMoney, baseTotal, updateSummary, dismiss, busy: false };
    modal.querySelectorAll('input[ref="quantityInput"]').forEach((input) => { input.value = '0'; });
    modal.querySelector('[data-upsell-error]').hidden = true;
    updateOfferUpsell();
    modal.openModal({ triggerElement: trigger, updateUrl: false });
    return true;
}

function updateOfferUpsell() {
    if (!activeOfferUpsell) return;
    const { modal, formatMoney, baseTotal, busy } = activeOfferUpsell;
    let subtotal = 0;
    let compareTotal = 0;
    let count = 0;
    modal.querySelectorAll('[data-upsell-item]').forEach((row) => {
        const input = row.querySelector('input[ref="quantityInput"]');
        const quantity = Math.max(0, Number(input.value) || 0);
        row.dataset.upsellSelected = String(quantity > 0);
        const option = row.querySelector('[data-upsell-option]:checked');
        const price = Number(option?.dataset.price ?? row.dataset.price);
        row.querySelector('[data-upsell-price]').textContent = formatMoney(price);
        const originalPrice = row.querySelector('[data-upsell-original-price]');
        if (originalPrice) {
            originalPrice.textContent = formatMoney(Number(row.dataset.price));
            originalPrice.hidden = !option || option.value === 'one-time' || price >= Number(row.dataset.price);
        }
        subtotal += quantity * price;
        compareTotal += quantity * Number(row.dataset.comparePrice || row.dataset.price);
        count += quantity;
    });
    activeOfferUpsell.updateSummary({ price: baseTotal + subtotal, compareExtras: compareTotal });
    modal.querySelector('[data-action="upsell:add"]').disabled = busy || count === 0;
}

function handleOfferUpsellSelect(event, el) {
    event.preventDefault();
    if (!activeOfferUpsell || activeOfferUpsell.busy) return;
    const row = el.closest('[data-upsell-item]');
    // Use the native stepper so inventory limits and quantity rules stay centralized.
    row.querySelector('button[name="plus"]').click();
}

async function handleOfferUpsellAdd(event) {
    event.preventDefault();
    const flow = activeOfferUpsell;
    if (!flow || flow.busy) return;
    const items = [];
    for (const row of flow.modal.querySelectorAll('[data-upsell-item]')) {
        const input = row.querySelector('input[ref="quantityInput"]');
        const quantity = Number(input.value);
        if (!input.reportValidity()) return;
        if (!Number.isInteger(quantity) || quantity < 0) return;
        if (!quantity) continue;
        const minimum = Number(input.dataset.min || 1);
        if (quantity < minimum) {
            showOfferUpsellError(flow, `Please choose at least ${minimum} for this item, or set its quantity to zero.`);
            input.focus();
            return;
        }
        const option = row.querySelector('[data-upsell-option]:checked');
        const isSubscription = option && option.value !== 'one-time';
        items.push({
            id: Number(row.dataset.variantId),
            quantity,
            ...(isSubscription ? { selling_plan: Number(option.value) } : {}),
        });
    }
    if (!items.length) return;
    await submitOfferUpsell(flow, items);
}

async function submitOfferUpsell(flow, items) {
    setOfferUpsellBusy(flow, true);
    flow.modal.querySelector('[data-upsell-error]').hidden = true;
    try {
        await flow.submit(items);
        // Clear ownership before closing so modal:closed cannot complete the flow twice.
        activeOfferUpsell = null;
        setOfferUpsellBusy(flow, false);
        await flow.complete();
    } catch (error) {
        showOfferUpsellError(flow, 'We could not add your items. Please check availability and try again.');
        console.error('Offer upsell submission failed', error);
    } finally {
        setOfferUpsellBusy(flow, false);
        if (activeOfferUpsell) updateOfferUpsell();
    }
}

async function handleOfferUpsellSkip(event) {
    event?.preventDefault();
    const flow = activeOfferUpsell;
    if (!flow || flow.busy) return;
    await submitOfferUpsell(flow, []);
}

function handleOfferUpsellClose() {
    const flow = activeOfferUpsell;
    if (!flow) return;
    if (flow.busy) return;
    // Dismissal is not the explicit Skip/Continue purchase action.
    activeOfferUpsell = null;
    flow.dismiss?.();
}

function setOfferUpsellBusy(flow, busy) {
    flow.busy = busy;
    flow.modal.setAttribute('aria-busy', String(busy));
    flow.modal.querySelector(SELECTORS.offerUpsell).inert = busy;
    flow.modal.querySelector('[data-action="modal:close"]').disabled = busy;
}

function showOfferUpsellError(flow, message) {
    const error = flow.modal.querySelector('[data-upsell-error]');
    error.textContent = message;
    error.hidden = false;
}
